import {
    APP_TITLE,
    LANDING_BRIEF,
    LANDING_LANGUAGE_SELECTOR,
    LANDING_COUNTRY_SELECTOR,
    LANDING_TERMS,
    LANDING_TERMS_ERROR,
    LANDING_CAPTCHA_ERROR,
    BUTTON_PREV,
    BUTTON_NEXT,
    BUTTON_SUBMIT,
    MENU_FEEDBACK_FORM,
    MENU_FEEDBACK_STATUS,
    MENU_FORM_INTAKE,
    MENU_FORM_EVENT_DETAILS,
    MENU_FORM_PRODUCT_INFO,
    SYSTEM_FEEDBACK_FORM,
    SYSTEM_FEEDBACK_STATUS,
    FORM_TITLE,
    FORM_MANDATORY_FIELDS,
    APP_DESCRIPTION,
    SUBMIT_FEEDBACK,
    CHECK_SUBMITTED_FEEDBACK,
    BTN_LAUNCH_FORM,
    BTN_CHECK_STATUS,
    SELECT_RESPONSE,
    FUNCTION_ROLE,
    CUSTOMER_ACCOUNT_NUMBER,
    ENTER_CUSTOMER_ACCOUNT,
    HELP_CUSTOMER_ACCOUNT_NUMBER,
    EVENT_REPORTED,
    REFERENCE_NUMBER,
    ENTER_REFERENCE,
    WHO_REPORTED_TO,
    WHO_WAS_NOTIFIED,
    ENTER_NAME,
    YOUR_NAME,
    OCCUPATION,
    PHONE_NUMBER,
    ENTER_PHONE_NUMBER,
    ENTER_EMAIL,
    EMAIL_ADDRESS,
    ENTER_ADDRESS,
    ENTER_NA_IF_UNKNOWN,
    FACILITY_HOSPITAL,
    ENTER_FACILITY,
    ADDRESS_1,
    ADDRESS_2,
    CITY,
    STATE,
    POSTAL_CODE,
    COUNTRY,
    END_USER_CUSTOMER,
    ADDITIONAL_CONTACT_PERSON,
    ADDITIONAL_PHONE,
    ADDITIONAL_EMAIL,
    ANOTHER_FACILITY_ADDRESS,
    ANOTHER_FACILITY_HOSPITAL,
    ANOTHER_ENTER_FACILITY,
    ANOTHER_ADDRESS_1,
    ANOTHER_ADDRESS_2,
    ANOTHER_CITY,
    ANOTHER_STATE,
    ANOTHER_POSTAL_CODE,
    ANOTHER_COUNTRY,
    LOT_SERIAL_NUMBER,
    ENTER_LOT_SERIAL_NUMBER,
    HELP_LOT_SERIAL_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
    PRODUCT_CODE,
    ENTER_PRODUCT_CODE,
    HELP_PRODUCT_CODE,
    NDC,
    ENTER_NDC,
    UDI,
    ENTER_UDI,
    PRODUCT_NAME,
    ENTER_PRODUCT_NAME,
    HELP_PRODUCT_NAME,
    BEST_DESCRIBES,
    QUANTITY_TO_SELECT,
    ENTER_QUANTITY,
    HELP_QUANTITY,
    UNIT,
    AVAILABLE_TO_RETURNED,
    PHOTOGRAPH_AVAILABLE,
    HELP_PHOTOGRAPH_AVAILABLE,
    UPLOAD_IMAGES,
    REPORTER_NAME,
    REPORTER_FACILITY,
    REPORTER_OCCUPATION,
    ENTER_NUMBER,
    REPORTER_PHONE_NUMBER,
    REPORTER_EMAIL_ADDRESS,
    EMPLOYEE_NAME,
    EMPLOYEE_PHONE_NUMBER,
    EMPLOYEE_EMAIL_ADDRESS,
    RETURNING_FOR_INVESTIGATION,
    HELP_RETURNING_FOR_INVESTIGATION,
    UNUSED_VANTIVE_PRODUCT,
    YOU_INDICATED_SAMPLES,
    SAMPLE_RETURN_KIT,
    A_BOX_WITH_A_PREPAID_LABEL,
    SAME_AS_MY_ADDRESS,
    OTHER_CONTACT_NAME,
    OTHER_CONTACT_OCCUPATION,
    OTHER_CONTACT_PHONE_NUMBER,
    OTHER_CONTACT_EMAIL_ADDRESS,
    MANUFACTURED_BY_ANOTHER_COMPANY,
    CUSTOMER_EXPLICITLY_REQUEST,
    EXPLICITLY_REQUEST_CREDIT,
    PRODUCT_FROM_VANTIVE,
    QUANTITY_REQUESTED_CREDIT,
    ENTER_OCCUPATION,
    LOT_QUANTITY_NUMBER,
    WHOLESALERS_NAME,
    PLACE_WHOLESALERS_NAME,
    DATE_OF_EVENT,
    DATE_OF_EVENT_MSG,
    HELP_DATE_OF_EVENT,
    DATE_VANTIVE_EMPLOYEE,
    DURING_WHAT_PROCESS,
    WAS_THE_PATIENT,
    WERE_YOU_CONNECTED,
    PROVIDE_ANY_ADDITIONAL,
    HELP_YOU_IDENTIFIED_MORE,
    ENTER_DETAILS,
    PROVIDE_ANY_ATTACHMENT,
    WAS_NEGATIVE_MEDICAL,
    WAS_MEDICAL_INTERVENTION,
    PROVIDE_DETAILS,
    REQUIRED_TREATMENT,
    ENTER_TREATMENT,
    RELEVANT_TESTS,
    HELP_RELEVANT_TESTS,
    RELEVANT_MEDICAL_HISTORY,
    ENTER_HISTORY,
    PATIENT_NAME,
    PATIENT_INITIALS,
    PATIENT_PHONE_NUMBER,
    PATIENT_EMAIL_ADDRESS,
    I_DO_NOT_WISH_TO_PROVIDE,
    PATIENT_ADDRESS,
    SAME_ADDRESS,
    DRUG_BEING_USED,
    PATIENT_IDENTIFIER,
    PATIENT_AGE_OR_DOB,
    ENTER_PATIENT_AGE,
    PATIENT_GENDER,
    PATIENT_WEIGHT,
    ENTER_WEIGHT,
    PATIENT_WEIGHT_UNIT,
    MY_NAME,
    ENTER_IN_YOUR_CONTACT,
    MY_PHONE_NUMBER,
    MY_EMAIL_ADDRESS,
    MY_ADDRESS,
    NAME_OF_VANTIVE_DRUG,
    ENTER_DRUG_NAME,
    PLEASE_PROVIDE_THE_NAME,
    APPLY_TO_EACH_UNIT,
    SELECT_THE_COMPONENT,
    USE_THE_DIAGRAM,
    TYPE_OF_DAMAGE,
    PLEASE_ENTER_VALUE,
    WAS_THE_PRODUCT_KINKED,
    WERE_ANY_CLEANING,
    WHAT_WAS_THE_DISINFECTANT,
    NOTE_VANTIVE_LABELING,
    SELECT_ALL_THAT_APPLY,
    DID_FOLLOWING_OCCUR,
    SELECT_THE_LOCATION,
    WAS_THE_PRODUCT_EXPOSED,
    HOW_LONG_TRANSFER,
    WAS_THERE_DIFFICULTY,
    WAS_DEVICE_OR_TOOL,
    DESCRIBE_HOW_PRODUCT,
    DID_YOU_OBSERVE,
    WERE_DIFFICULTIES_PUTTING,
    WAS_THE_TRANSFER,
    SELECT_TYPE_OF_FLOW,
    WAS_ANYTHING_BLOCKING,
    WAS_ANY_ALARM,
    SELECT_BEST_DESCRIBE,
    WERE_THE_MINICAPS,
    WAS_THE_SPONGE_VISIBLE,
    WHERE_PARTICULATE_MATTERFOREIGN,
    DESCRIBE_THE_EXACT_LOCATION,
    WAS_THE_PARTICULATE_MATTER,
    DOES_THE_PARTICULATE_MATER,
    WHAT_COMPONENT_DOES,
    SELECT_CONNECTION_ISSUE,
    WERE_ASSIST_DEVICES,
    WERE_ANY_DIFFICULTIES,
    PROVIDE_PRODUCT_INFORMATION,
    WERE_THE_SPIKE_LUER,
    VANTIVE_LABELING_STATES,
    WERE_PETS_OR_ANIMALS,
    VANTIVE_LABELING_CONTAMINATION,
    WERE_OTHER_ISSUES,
    WAS_MINICAP_TWISTED,
    WERE_DIFFICULTIES_TRANSFER_SET,
    DID_TRANSFER_SET_CONNECTORS,
    WHAT_WAS_THE_ALARM,
    WHERE_OBSERVED_DAMAGE,
    SELECT_THE_TYPE_OBSERVED,
    DID_DAMAGE_CAUSE_LEAK,
    WAS_THE_SHIPPING_CARTON,
    SELECT_FLOW_ISSUE_OBSERVED,
    HOW_LONG_WAS_STORAGE,
    WAS_THERE_AN_ADAPTER,
    NAME_AND_MODEL,
    NAME_VAPORIZER,
    WAS_VIAL_INVERTED,
    WHAT_VIAL_USED,
    DRUG_NAME_MANUFACTURER,
    WERE_BREAK_FRANGIBLE,
    WAS_ALARM_ASSOCIATED,
    WHAT_PART_DISCOLORED,
    DESCRIBE_DISCOLORATION,
    HOW_PRODUCT_STORED,
    DOES_DISCOLORATION_APPEAR,
    WHICH_CHAMBER_DISCOLORED,
    WAS_PEEL_SEAL_INTERCHAMBER,
    WAS_DISCOLORATION_NOTICED,
    SELECT_SPECIFICALLY_DESCRIBES,
    WHAT_DEVICE_HAD_ALARM,
    WHAT_MISSING_MISASSEMBLED,
    RECONSTITUTION_ISSUE,
    WHAT_MEDICATION_SOLUTION,
    WHAT_VOLUME_MEDICATION,
    WHAT_DEVICES_RECONSTITUTION,
    WAS_PRODUCT_EXPOSED_HEAT,
    DESCRIBE_EXPOSURE,
    WHAT_USED_ACTIVATE_SOLUTION,
    WAS_DAMAGE_OBSERVED,
    DESCRIBE_THE_DAMAGE,
    APPROXIMATELY_SOLUTION_POWDER,
    WAS_LEAK_OBSERVED,
    WHAT_FEATUR_DIFFICULT_USE,
    HOW_WAS_DIFFICULT_USE,
    WHERE_MATTER_FOREIGN,
    DOES_PARTICULATE_MATTER,
    DESCRIBE_EXACT_LOCATION,
    WAS_MATTER_FOREIGN,
    WHEN_MATTER_FOREIGN,
    PROVIDE_INFORMATION_MEDICATION,
    PRODUCT_NAME_CODE_NUMBER,
    DESCRIBE_SPIKING,
    INCLUDE_NEEDLE,
    WHAT_ADMINISTRATION_RECONSTITUTION,
    INCLUDE_MANUFACTURER,
    WAS_MEDICATION_ADDITIVE,
    WHAT_MEDICATION_ADDITIVE,
    WHAT_STATE_OF_PRODUCT,
    AFTER_UNITS_SAT,
    DID_ATTEMPT_AGITATE,
    DID_PRECIPITATE_DISSOLVE,
    WHAT_STORAGE_TEMPERATURE,
    PROVIDE_TEMPERATURE_LOCATION,
    ARE_TEMPERATURE_LOGS,
    LOGS_CAN_BE_ATTACHED,
    IS_THE_STORAGE_UNIT,
    HOW_PRODUCT_THAWED,
    WHAT_STORAGE_CONDITIONS,
    WAS_ANY_DAMAGE,
    MORE_SPECIFIC_INFORMATION,
    WHAT_PURPOSE_INDICATION,
    WHAT_ROUTE_ADMINISTRATION,
    WHAT_DATE_ADMINISTRATION,
    WHAT_DOSAGE_STRENGTH,
    WAS_RECENT_PRESCRIPTION,
    WHAT_WAS_STORAGE_TEMPERATURE,
    WERE_ANY_ADJUSTMENTS,
    SELECT_APPROPRIATE_DESCRIPTION,
    SELECT_LABELING_ISSUE,
    WAS_CONNECTION_SECURE,
    WAS_EXPIRED_PRODUCT,
    WAS_COMPONENT_DAMAGED,
    WERE_ABNORMALITIES_DAMAGE,
    WHAT_PURCHASE_ORDER_NUMBER,
    WHAT_DATE_OF_ADMINISTRATION,
    WHAT_WAS_EXPIRATION_DATE,
    DESCRIBE_WAS_INCORRECT,
    WHAT_SCANNER_USED,
    WAS_OVERPOUCH_POUCH,
    WHAT_BACKGROUND_COLOR,
    DO_ALL_OF_THE_LABELS,
    PRODUCT_INFORMATION,
    IS_A_BARCODE_SCANNER,
    HOW_ARE_THESE_PRODUCTS,
    WHAT_INFORMATION_INCORRECTLY,
    WAS_THERE_LEAK,
    WHERE_LEAK_OBSERVED,
    WAS_FRANGIBLE_OBSERVED,
    IS_MOISTURE_CLEAR,
    WHO_IS_YOUR_DISTRIBUTOR,
    WHAT_MANUFACTURER_MEDICATION,
    WHAT_GAUGE_NEEDLE,
    WHAT_ADMINISTRATION_SET,
    WAS_DIFFICULTY_SPIKING,
    WERE_FOLLOWING_SCENARIOS,
    WAS_FRANGIBLE_OBSERVED_DEFECT,
    WHAT_AMOUNT_PRESSURE,
    WAS_BAG_COMPLETELY,
    WHAT_MANUFACTURER_MODEL,
    WHAT_PRESSURE_PRIOR,
    LIST_THE_VAPORIZER,
    APPROXIMATELY_HOW_MUCH,
    WAS_THE_BOTTLE_DIFFICULT,
    WERE_VISIBLE_DEFECTS,
    SELECT_THE_OPTION,
    PROVIDE_INVOLVED_CONNECTION_ISSUE,
    WHICH_PART_SEPARATED,
    WHAT_COMPONENT_DISCOLORED,
    SELECT_DESCRIBES_DISCOLORATION,
    WAS_THE_SET_DISCOLORED,
    DID_SET_CHANGE_COLOR,
    WHAT_MEDICATION_ADDED,
    WHERE_MATERIAL_LOCATED,
    DESCRIBE_APPEARANCE_COLOR_SIZE,
    WAS_EMBEDDED_PLASTIC,
    WAS_THERE_A_PRECIPITATE,
    WHAT_MEDICATIONS_SOLUTIONS,
    WHERE_DAMAGE_COMPONENT_AFFECTED,
    WHAT_DAMAGE_ISSUE,
    DID_ISSUE_RESULT,
    WAS_PATIENT_CONNECTED,
    WAS_PRODUCT_REPLACED,
    WHICH_SITUATION_BEST,
    SELECT_MOST_LABELING_ISSUE,
    WHAT_INFORMATION_DISPLAYED,
    WHAT_SCANNER_WAS_USED,
    INCLUDE_THE_MODEL_NAME,
    WAS_PRODUCT_ORDERED,
    WHERE_LEAK_COMING,
    DID_SCENARIOS_OCCURRED_LEAK,
    WAS_POWER_INJECTOR,
    WHAT_INJECTOR_USED,
    MANUFACTURER_NAME_CODE_LOT,
    DESCRIBE_INCORRECT_INCOMPLETE,
    PROVIDE_INFORMATION_SECOND_PRODUCT,
    WHICH_COMPONENTS_WERE_FOUND,
    DESCRIBE_CUT_HOLE_SLICE,
    WAS_LEAK_ORIGINATING,
    PROVIDE_DISCONNECTION_CONNECTION,
    WHICH_SPECIFIC_BONDED,
    WERE_VISIBLE_IRREGULARITIES,
    WAS_SUCCESSFUL_CONNECTION,
    WAS_TOOL_USED_ASSIST,
    WERE_LUER_CONNECTIONS,
    WAS_PRODUCT_SECURELY,
    WHICH_DESCRIBES_FLOW_ISSUE,
    WHAT_FLOWING_BACKWARDS,
    DESCRIBE_COMPONENTS_BACKFLOW,
    DO_SITUATIONS_APPLY,
    WHICH_SPECIFIC_AREA,
    WAS_FLOW_PREVIOUSLY_SEEN,
    WAS_ANY_FOLLOWING_OBSERVED,
    WHERE_SIMULTANEOUS_FLOW,
    WHAT_TYPE_HANGER,
    WHAT_WAS_HANGER_LENGTH,
    WHICH_BAG_LOWER,
    WHAT_Y_SITE_WAS,
    WHAT_COMPONENT_WITHIN,
    WAS_COMPONENT_SET_REPLACED,
    WHAT_VOLUME_FLUID_PERIOD_TIME,
    WHAT_VOLUME_FLUID_OVER_TIME,
    WAS_USED_WITH_PUMP,
    DID_CLAMP_FAIL,
    WHAT_CLAMP_FAILED,
    WAS_ISSUES_OBSERVED_CLAMP,
    DO_OTHER_SITUATIONS_DESCRIBE,
    DESCRIBE_ALARM_OBSERVED,
    INCLUDE_ANY_MESSAGES,
    WHICH_CLAMP_HAD_ISSUE,
    WHICH_TYPE_CLAMP_ISSUE,
    SELECT_BEST_DESCRIBES_ISSUE,
    PROVIDE_MORE_DETAILS,
    PROVIDE_MORE_DETAILS_INSTRUCTIONS,
    DESCRIBE_THE_SMELL,
    WAS_ISSUES_WITH_SET,
    WHERE_LEAK_LOCATED,
    DID_OCCUR_WITH_LEAK,
    PROVIDE_INVOLVED_DISCONNECTION,
    DID_OCCURRED_WITH_THE_LEAK,
    WHERE_WAS_PRODUCT_DAMAGED,
    SELECT_ALL_APPLY,
    DESCRIBE_OBSERVED_DAMAGE,
    WHAT_COMPONENT_IS_DISCOLORED,
    DESCRIBE_HUE_TINT_SHADE,
    INSIDE_OUTSIDE_OVERPOUCH,
    DESCRIBE_EXACT_LOCATION_SIZE,
    DOES_THE_PARTICULATE_MATTER,
    WAS_PARTICULATE_MATERIAL_EMBEDDED,
    DOES_APPEAR_PRODUCT_MATERIAL,
    WHERE_DID_THE_ISSUE_OCCUR,
    LIST_COMPONENTS_IF,
    WERE_THERE_VISIBLE_IRREGULARITIES,
    SELECT_OPTION_FLOW_ISSUE,
    DESCRIBE_IRREGULARITIES,

    HOW_PRODUCT_SETUP,
    SELECT_MOST_APPROPRIATE_DESCRIPTION,
    DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
    WAS_SHIPPING_CARTON_DAMAGED,
    WHAT_PRODUCT_WAS_SUPPOSED,
    IF_PRODUCT_CODE_NOT,
    WAS_THE_CASE_MISSING,
    WHAT_CARRIER_DELIVERED,
    WHAT_IS_PURCHASE_ORDER_NUMBER,
    WHAT_QUANTITY_MISSING_UNITS,
    WAS_EXPIRED_PRODUCT_USE,
    ADD_PRODUCT_TO_THE_GRID,
    SAVE,
    CANCEL,
    ADD_MORE_PRODUCTS,
    REPORTER_ADDRESS,
    ATTACHMENTS,
    COPYRIGHT,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    COOKIE_POLICY,
    FORM_SUB_TITLE,
    OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
    OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
    OPTION_FUNCTIONOPTIONS_CAREGIVER,
    OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
    OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
    OPTION_FUNCTIONOPTIONS_PATIENT,
    OPTION_FUNCTIONOPTIONS_OTHER,
    OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
    OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
    OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
    OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
    OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
    OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
    OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_OCCUPATIONOPTIONS_NURSE,
    OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_UNITOPTIONS_BOXES,
    OPTION_UNITOPTIONS_PALLETS,
    OPTION_UNITOPTIONS_UNITS,
    OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
    OPTION_PROBLEMOPTIONS_DAMAGE,
    OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
    OPTION_PROBLEMOPTIONS_DISCOLORED,
    OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
    OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
    OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
    OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
    OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
    OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
    OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
    OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
    OPTION_PATIENTSEXOPTIONS_FEMALE,
    OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
    OPTION_PATIENTSEXOPTIONS_MALE,
    OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
    OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
    OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
    OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
    OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
    OPTION_REPORTEDTOOPTIONS_VANTIVE,
    OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
    OPTION_REPORTEDTOOPTIONS_EMA,
    OPTION_REPORTEDTOOPTIONS_FDA,
    OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
    OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
    OPTION_REPORTEDTOOPTIONS_TUV,
    OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
    OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
    OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
    OPTION_DAMAGEMINICAPOPTIONS_CARTON,
    OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
    OPTION_DAMAGEMINICAPOPTIONS_POUCH,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
    OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
    OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
    OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
    OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
    OPTION_BLOCKINGFLOWOPTIONS_KINK,
    OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
    OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
    OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
    OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
    OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
    OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
    OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
    OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
    OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
    OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
    OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
    OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
    OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
    OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
    OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
    OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
    OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
    OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
    OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
    OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
    OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
    OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_DESCOFISSUEOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
    OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
    OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
    OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
    OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
    OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
    OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
    OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
    OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
    OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
    OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
    NO_DESCRIBE_THE_COLOR,
    OPTION_LIQUIDSPILLEDOPTIONS_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
    OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
    OPTION_VISIBLEDEFECTSOPTIONS_CAP,
    OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
    OPTION_VISIBLEDEFECTSOPTIONS_NONE,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
    OTHER_PLEASE_SPECIFY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
    OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
    OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
    OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
    OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
    OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
    DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
    DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
    OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
    OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
    OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
    OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
    OPTION_LEAKCOMINGFROMOPTIONS_CAP,
    OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
    OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
    OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
    OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
    OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
    OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
    OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
    OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
    OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
    OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
    DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
    YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
    OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
    OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
    OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
    OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
    OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
    OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
    OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
    OPTION_BAGLOWEROPTIONS_PRIMARY,
    OPTION_BAGLOWEROPTIONS_SECONDARY,
    OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
    OPTION_YSITECONNECTEDOPTIONS_LOWER,
    OPTION_YSITECONNECTEDOPTIONS_UPPER,
    OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
    OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
    OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
    OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
    OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
    OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
    OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
    OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
    OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
    OPTION_LEAKOCCUROPTIONS_OTHER,
    OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
    OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
    OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
    OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
    OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
    OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
    OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
    OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
    OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
    OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
    OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
    OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
    OPTION_ALARMOPTIONS_YES_SPECIFY,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
    OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
    OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
    OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
    OPTION_COMPONENTHADISSUEOPTIONS_LINES,
    OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
    OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
    OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
    OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
    OPTION_MONTHOPTIONS_JAN,
    OPTION_MONTHOPTIONS_FEB,
    OPTION_MONTHOPTIONS_MAR,
    OPTION_MONTHOPTIONS_APR,
    OPTION_MONTHOPTIONS_MAY,
    OPTION_MONTHOPTIONS_JUN,
    OPTION_MONTHOPTIONS_JUL,
    OPTION_MONTHOPTIONS_AUG,
    OPTION_MONTHOPTIONS_SEP,
    OPTION_MONTHOPTIONS_OCT,
    OPTION_MONTHOPTIONS_NOV,
    OPTION_MONTHOPTIONS_DEC,
    OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
    OPTION_PROBLEMOPTIONS_OTHER,
    OPTION_REPORTEDTOOPTIONS_OTHER,
    OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
    OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
    OPTION_BLOCKINGFLOWOPTIONS_OTHER,
    OPTION_DESCRIBEISSUEOPTIONS_OTHER,
    OPTION_MATERIALLOCATEDOPTIONS_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
    OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
    OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_OTHER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
    OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
    OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
    OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
    OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
    OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
    OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
    OPTION_ADDANOTHERFACILITYOPTIONS_NO,
    OPTION_ADDANOTHERFACILITYOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_NO,
    OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
    OPTION_PATIENINVOLVEMENTOPTIONS_YES,
    OPTION_OTHERFACILITYREPORTOPTIONS_NO,
    OPTION_OTHERFACILITYREPORTOPTIONS_YES,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
    OPTION_AVAILABILITYOPTIONS_NO,
    OPTION_AVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYOPTIONS_NO,
    OPTION_MEDIAAVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
    OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
    OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
    OPTION_COUNTERACTIONOPTIONS_NO,
    OPTION_COUNTERACTIONOPTIONS_YES,
    OPTION_DRUGUSEDOPTIONS_NO,
    OPTION_DRUGUSEDOPTIONS_YES,
    OPTION_SHARECONTACTOPTIONS_NO,
    OPTION_SHARECONTACTOPTIONS_YES,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
    OPTION_DIRECTORDEROPTIONS_NO,
    OPTION_DIRECTORDEROPTIONS_YES,
    OPTION_EXCESSIVEFORCEOPTIONS_NO,
    OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
    OPTION_EXCESSIVEFORCEOPTIONS_YES,
    OPTION_TWISTCLAMPOPTIONS_NO,
    OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TWISTCLAMPOPTIONS_YES,
    OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
    OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_NO,
    OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_YES,
    OPTION_SPONGEVISIBLEOPTIONS_NO,
    OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
    OPTION_SPONGEVISIBLEOPTIONS_YES,
    OPTION_MATERIALEMBEDDEDOPTIONS_NO,
    OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_MATERIALEMBEDDEDOPTIONS_YES,
    OPTION_PIECESMATERIALOPTIONS_NO,
    OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
    OPTION_PIECESMATERIALOPTIONS_YES,
    OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
    OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
    OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
    OPTION_INITIALCONNECTIONOPTIONS_NO,
    OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
    OPTION_INITIALCONNECTIONOPTIONS_YES,
    OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
    OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
    OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
    OPTION_PETSORANIMALSOPTIONS_NO,
    OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
    OPTION_PETSORANIMALSOPTIONS_YES,
    OPTION_MINICAPTWISTEDOPTIONS_NO,
    OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
    OPTION_MINICAPTWISTEDOPTIONS_YES,
    OPTION_TRANSFERSETOPTIONS_NO,
    OPTION_TRANSFERSETOPTIONS_UNKNOWN,
    OPTION_TRANSFERSETOPTIONS_YES,
    OPTION_RESIDUETHREADSOPTIONS_NO,
    OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_NO,
    OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_YES,
    OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
    OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
    OPTION_ADAPTERDEVICEOPTIONS_NO,
    OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
    OPTION_ADAPTERDEVICEOPTIONS_YES,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
    OPTION_FORTHMOTIONOPTIONS_NO,
    OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
    OPTION_FORTHMOTIONOPTIONS_YES,
    OPTION_ALARMNOFLOWOPTIONS_NO,
    OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
    OPTION_ALARMNOFLOWOPTIONS_YES,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
    OPTION_BROKENACTIVATEDOPTIONS_NO,
    OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
    OPTION_BROKENACTIVATEDOPTIONS_YES,
    OPTION_vaporizerSightGlassOptions_NO,
    OPTION_vaporizerSightGlassOptions_UNKNOWN,
    OPTION_vaporizerSightGlassOptions_YES,
    OPTION_PRODUCTHEATOPTIONS_NO,
    OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
    OPTION_PRODUCTHEATOPTIONS_YES,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
    OPTION_LEAKOBSERVEDOPTIONS_NO,
    OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
    OPTION_LEAKOBSERVEDOPTIONS_YES,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
    OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
    OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
    OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
    OPTION_AGITATEUNITOPTIONS_NO,
    OPTION_AGITATEUNITOPTIONS_UNKNOWN,
    OPTION_AGITATEUNITOPTIONS_YES,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
    OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
    OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
    OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
    OPTION_EXPIREDPRODUCTOPTIONS_NO,
    OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTOPTIONS_YES,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
    OPTION_BARCODESCANNEROPTIONS_NO,
    OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
    OPTION_BARCODESCANNEROPTIONS_YES,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
    OPTION_FRANGIBLEBROKENOPTIONS_NO,
    OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEBROKENOPTIONS_YES,
    OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
    OPTION_MOISTURECLEAROPTIONS_YES,
    OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
    OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
    OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
    OPTION_PRESSURECUFFOPTIONS_NO,
    OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
    OPTION_PRESSURECUFFOPTIONS_YES,
    OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
    OPTION_ADDINGMEDICATIONOPTIONS_NO,
    OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
    OPTION_ADDINGMEDICATIONOPTIONS_YES,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
    OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
    OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
    OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
    OPTION_WASPOWERINJECTOROPTIONS_NO,
    OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
    OPTION_WASPOWERINJECTOROPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
    OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
    OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
    OPTION_TOOLUSEDASSISTOPTIONS_NO,
    OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_NO,
    OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_YES,
    OPTION_PRIORDISCONNECTINGOPTIONS_NO,
    OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
    OPTION_PRIORDISCONNECTINGOPTIONS_YES,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
    OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
    OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
    OPTION_WITHPUMPOPTIONS_NO,
    OPTION_WITHPUMPOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_NO,
    OPTION_CLAMPFAILOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_YES,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
    OPTION_GELPACKSOPTIONS_NO,
    OPTION_GELPACKSOPTIONS_YES,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
    OPTION_ALARMOPTIONS_NO,
    OPTION_ALARMOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
    OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_NO,
    OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_YES,
    OPTION_FULLYTIGHTENEDOPTIONS_NO,
    OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
    OPTION_FULLYTIGHTENEDOPTIONS_YES,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_NO,
    OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_YES,
    OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
    OPTION_EXPLICITLYREQUESTOPTIONS_NO,
    OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
    OPTION_EXPLICITLYREQUESTOPTIONS_YES,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
    OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
    OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
    OPTION_HANGERUSEDOPTIONS_UNKNOWN,
    OPTION_HANGERUSEDOPTIONS_NONE,
    OPTION_BAGLOWEROPTIONS_UNKNOWN,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
    OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
    OPTION_WEIGHTUNITOPTIONS_POUND,
    OPTION_INFUSATESOLUTIONOPTIONS_NO,
    OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
    PLEASE_ENTER_THE_VALUE,
    PLEASE_SELECT_THE_VALUE,
    PLEASE_SELECT_THE_DATE,
    PLEASE_CHOOSE_THE_VALUE,
    OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
    OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
    OPTION_COUNTRYOPTIONS_KOSOVO,
    OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
    OPTION_COUNTRYOPTIONS_AFGHANISTAN,
    OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
    OPTION_COUNTRYOPTIONS_ALBANIA,
    OPTION_COUNTRYOPTIONS_ALGERIA,
    OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
    OPTION_COUNTRYOPTIONS_ANDORRA,
    OPTION_COUNTRYOPTIONS_ANGOLA,
    OPTION_COUNTRYOPTIONS_ANGUILLA,
    OPTION_COUNTRYOPTIONS_ANTARCTICA,
    OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
    OPTION_COUNTRYOPTIONS_ARGENTINA,
    OPTION_COUNTRYOPTIONS_ARMENIA,
    OPTION_COUNTRYOPTIONS_ARUBA,
    OPTION_COUNTRYOPTIONS_AUSTRALIA,
    OPTION_COUNTRYOPTIONS_AUSTRIA,
    OPTION_COUNTRYOPTIONS_AZERBAIJAN,
    OPTION_COUNTRYOPTIONS_BAHAMAS,
    OPTION_COUNTRYOPTIONS_BAHRAIN,
    OPTION_COUNTRYOPTIONS_BANGLADESH,
    OPTION_COUNTRYOPTIONS_BARBADOS,
    OPTION_COUNTRYOPTIONS_BELARUS,
    OPTION_COUNTRYOPTIONS_BELGIUM,
    OPTION_COUNTRYOPTIONS_BELIZE,
    OPTION_COUNTRYOPTIONS_BENIN,
    OPTION_COUNTRYOPTIONS_BERMUDA,
    OPTION_COUNTRYOPTIONS_BHUTAN,
    OPTION_COUNTRYOPTIONS_BOLIVIA,
    OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
    OPTION_COUNTRYOPTIONS_BOTSWANA,
    OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
    OPTION_COUNTRYOPTIONS_BRAZIL,
    OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
    OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
    OPTION_COUNTRYOPTIONS_BULGARIA,
    OPTION_COUNTRYOPTIONS_BURKINA_FASO,
    OPTION_COUNTRYOPTIONS_BURUNDI,
    OPTION_COUNTRYOPTIONS_CAMBODIA,
    OPTION_COUNTRYOPTIONS_CAMEROON,
    OPTION_COUNTRYOPTIONS_CANADA,
    OPTION_COUNTRYOPTIONS_CAPE_VERDE,
    OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
    OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_CHAD,
    OPTION_COUNTRYOPTIONS_CHILE,
    OPTION_COUNTRYOPTIONS_CHINA,
    OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
    OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
    OPTION_COUNTRYOPTIONS_COLOMBIA,
    OPTION_COUNTRYOPTIONS_COMOROS,
    OPTION_COUNTRYOPTIONS_CONGO,
    OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
    OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
    OPTION_COUNTRYOPTIONS_COSTA_RICA,
    OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
    OPTION_COUNTRYOPTIONS_CROATIA,
    OPTION_COUNTRYOPTIONS_CUBA,
    OPTION_COUNTRYOPTIONS_CYPRUS,
    OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
    OPTION_COUNTRYOPTIONS_DENMARK,
    OPTION_COUNTRYOPTIONS_DJIBOUTI,
    OPTION_COUNTRYOPTIONS_DOMINICA,
    OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_ECUADOR,
    OPTION_COUNTRYOPTIONS_EGYPT,
    OPTION_COUNTRYOPTIONS_EL_SALVADOR,
    OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
    OPTION_COUNTRYOPTIONS_ERITREA,
    OPTION_COUNTRYOPTIONS_ESTONIA,
    OPTION_COUNTRYOPTIONS_ETHIOPIA,
    OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
    OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
    OPTION_COUNTRYOPTIONS_FIJI,
    OPTION_COUNTRYOPTIONS_FINLAND,
    OPTION_COUNTRYOPTIONS_FRANCE,
    OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
    OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
    OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
    OPTION_COUNTRYOPTIONS_GABON,
    OPTION_COUNTRYOPTIONS_GAMBIA,
    OPTION_COUNTRYOPTIONS_GEORGIA,
    OPTION_COUNTRYOPTIONS_GERMANY,
    OPTION_COUNTRYOPTIONS_GHANA,
    OPTION_COUNTRYOPTIONS_GIBRALTAR,
    OPTION_COUNTRYOPTIONS_GREECE,
    OPTION_COUNTRYOPTIONS_GREENLAND,
    OPTION_COUNTRYOPTIONS_GRENADA,
    OPTION_COUNTRYOPTIONS_GUADELOUPE,
    OPTION_COUNTRYOPTIONS_GUAM,
    OPTION_COUNTRYOPTIONS_GUATEMALA,
    OPTION_COUNTRYOPTIONS_GUERNSEY,
    OPTION_COUNTRYOPTIONS_GUINEA,
    OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
    OPTION_COUNTRYOPTIONS_GUYANA,
    OPTION_COUNTRYOPTIONS_HAITI,
    OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
    OPTION_COUNTRYOPTIONS_HONDURAS,
    OPTION_COUNTRYOPTIONS_HONG_KONG,
    OPTION_COUNTRYOPTIONS_HUNGARY,
    OPTION_COUNTRYOPTIONS_ICELAND,
    OPTION_COUNTRYOPTIONS_INDIA,
    OPTION_COUNTRYOPTIONS_INDONESIA,
    OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_IRAQ,
    OPTION_COUNTRYOPTIONS_IRELAND,
    OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
    OPTION_COUNTRYOPTIONS_ISRAEL,
    OPTION_COUNTRYOPTIONS_ITALY,
    OPTION_COUNTRYOPTIONS_JAMAICA,
    OPTION_COUNTRYOPTIONS_JAPAN,
    OPTION_COUNTRYOPTIONS_JERSEY,
    OPTION_COUNTRYOPTIONS_JORDAN,
    OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
    OPTION_COUNTRYOPTIONS_KENYA,
    OPTION_COUNTRYOPTIONS_KIRIBATI,
    OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KUWAIT,
    OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
    OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    OPTION_COUNTRYOPTIONS_LATVIA,
    OPTION_COUNTRYOPTIONS_LEBANON,
    OPTION_COUNTRYOPTIONS_LESOTHO,
    OPTION_COUNTRYOPTIONS_LIBERIA,
    OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
    OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
    OPTION_COUNTRYOPTIONS_LITHUANIA,
    OPTION_COUNTRYOPTIONS_LUXEMBOURG,
    OPTION_COUNTRYOPTIONS_MACAO,
    OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_MADAGASCAR,
    OPTION_COUNTRYOPTIONS_MALAWI,
    OPTION_COUNTRYOPTIONS_MALAYSIA,
    OPTION_COUNTRYOPTIONS_MALDIVES,
    OPTION_COUNTRYOPTIONS_MALI,
    OPTION_COUNTRYOPTIONS_MALTA,
    OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
    OPTION_COUNTRYOPTIONS_MARTINIQUE,
    OPTION_COUNTRYOPTIONS_MAURITANIA,
    OPTION_COUNTRYOPTIONS_MAURITIUS,
    OPTION_COUNTRYOPTIONS_MAYOTTE,
    OPTION_COUNTRYOPTIONS_MEXICO,
    OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
    OPTION_COUNTRYOPTIONS_MOLDOVA,
    OPTION_COUNTRYOPTIONS_MONACO,
    OPTION_COUNTRYOPTIONS_MONGOLIA,
    OPTION_COUNTRYOPTIONS_MONTENEGRO,
    OPTION_COUNTRYOPTIONS_MONTSERRAT,
    OPTION_COUNTRYOPTIONS_MOROCCO,
    OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
    OPTION_COUNTRYOPTIONS_MYANMAR,
    OPTION_COUNTRYOPTIONS_NAMIBIA,
    OPTION_COUNTRYOPTIONS_NAURU,
    OPTION_COUNTRYOPTIONS_NEPAL,
    OPTION_COUNTRYOPTIONS_NETHERLANDS,
    OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
    OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
    OPTION_COUNTRYOPTIONS_NICARAGUA,
    OPTION_COUNTRYOPTIONS_NIGER,
    OPTION_COUNTRYOPTIONS_NIGERIA,
    OPTION_COUNTRYOPTIONS_NIUE,
    OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
    OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
    OPTION_COUNTRYOPTIONS_NORWAY,
    OPTION_COUNTRYOPTIONS_OMAN,
    OPTION_COUNTRYOPTIONS_PAKISTAN,
    OPTION_COUNTRYOPTIONS_PALAU,
    OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
    OPTION_COUNTRYOPTIONS_PANAMA,
    OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
    OPTION_COUNTRYOPTIONS_PARAGUAY,
    OPTION_COUNTRYOPTIONS_PERU,
    OPTION_COUNTRYOPTIONS_PHILIPPINES,
    OPTION_COUNTRYOPTIONS_PITCAIRN,
    OPTION_COUNTRYOPTIONS_POLAND,
    OPTION_COUNTRYOPTIONS_PORTUGAL,
    OPTION_COUNTRYOPTIONS_PUERTO_RICO,
    OPTION_COUNTRYOPTIONS_QATAR,
    OPTION_COUNTRYOPTIONS_RÉUNION,
    OPTION_COUNTRYOPTIONS_ROMANIA,
    OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
    OPTION_COUNTRYOPTIONS_RWANDA,
    OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
    OPTION_COUNTRYOPTIONS_SAINT_HELENA,
    OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
    OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
    OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
    OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
    OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
    OPTION_COUNTRYOPTIONS_SAMOA,
    OPTION_COUNTRYOPTIONS_SAN_MARINO,
    OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
    OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
    OPTION_COUNTRYOPTIONS_SENEGAL,
    OPTION_COUNTRYOPTIONS_SERBIA,
    OPTION_COUNTRYOPTIONS_SEYCHELLES,
    OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
    OPTION_COUNTRYOPTIONS_SINGAPORE,
    OPTION_COUNTRYOPTIONS_SLOVAKIA,
    OPTION_COUNTRYOPTIONS_SLOVENIA,
    OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
    OPTION_COUNTRYOPTIONS_SOMALIA,
    OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
    OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    OPTION_COUNTRYOPTIONS_SPAIN,
    OPTION_COUNTRYOPTIONS_SRI_LANKA,
    OPTION_COUNTRYOPTIONS_SUDAN,
    OPTION_COUNTRYOPTIONS_SURINAME,
    OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
    OPTION_COUNTRYOPTIONS_SWAZILAND,
    OPTION_COUNTRYOPTIONS_SWEDEN,
    OPTION_COUNTRYOPTIONS_SWITZERLAND,
    OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
    OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
    OPTION_COUNTRYOPTIONS_TAJIKISTAN,
    OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_THAILAND,
    OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
    OPTION_COUNTRYOPTIONS_TOGO,
    OPTION_COUNTRYOPTIONS_TOKELAU,
    OPTION_COUNTRYOPTIONS_TONGA,
    OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
    OPTION_COUNTRYOPTIONS_TUNISIA,
    OPTION_COUNTRYOPTIONS_TURKEY,
    OPTION_COUNTRYOPTIONS_TURKMENISTAN,
    OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
    OPTION_COUNTRYOPTIONS_TUVALU,
    OPTION_COUNTRYOPTIONS_UGANDA,
    OPTION_COUNTRYOPTIONS_UKRAINE,
    OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
    OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
    OPTION_COUNTRYOPTIONS_UNITED_STATES,
    OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    OPTION_COUNTRYOPTIONS_URUGUAY,
    OPTION_COUNTRYOPTIONS_UZBEKISTAN,
    OPTION_COUNTRYOPTIONS_VANUATU,
    OPTION_COUNTRYOPTIONS_VENEZUELA,
    OPTION_COUNTRYOPTIONS_VIET_NAM,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
    OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
    OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
    OPTION_COUNTRYOPTIONS_YEMEN,
    OPTION_COUNTRYOPTIONS_ZAMBIA,
    OPTION_COUNTRYOPTIONS_ZIMBABWE,
    LANDING_TERMS_I_HAVE_READ,
    LANDING_TERMS_THE_USE_DISCLOSURE,
    LANDING_TERMS_THE_TRANSFER_OF,
    LANDING_TERMS_I_UNDERSTAND_THAT,
    OPTION_DOESTHEPARTICULATEMATTER_NO,
    OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
    OPTION_DOESTHEPARTICULATEMATTER_YES,
    I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
    PRODUCT_LOT,
    SHIPPING_DISTRIBUTION_LABEL,
    CARTON_LABEL,
    INTERNAL_PRODUCT_LABEL,
    TITLE_PD_RENAL,
    TITLE_SOLUTIONS,
    TITLE_ACCESS,
    TITLE_ALL_OTHER_PRODUCT,
    REPORTED_PROBLEM,
    LOGIN,
    SYSTEM_MENU,
    INITIATE_PRODUCT_FEEDBACK,
    FEEDBACK_STATUS,
    OKTACALLBACK,
    VALID_EMAIL,
    VALID_NUMERIC,
    PLEASE_UPLOAD_IMAGE,
    VALID_DATE,
    QUANTITY,
    EDIT,
    DELETE,
    LOT_SERIAL_NO,
    LOT_NUMBER_NOT_FOUND,
    SEARCHING_LOT_NUMBER,
    PRODUCT_CODE_NOT_FOUND,
    SEARCHING_PRODUCT_CODE,
    FILE_OF_TYPES_ARE_NOT_ALLOWED,
    THE_FILE_YOU_ARE_ATTEMPTING,
    IMAGE_ICON,
    LOGIN_TO_ACCOUNT,
    SIGN_IN_TO_YOUR_ACCOUNT,
    PASSWORD,
    SIGN_IN,
    UNKNOWN,
    ASKED_UNKNOWN,
    DD_MMM_YYYY,
    DD,
    MMM,
    YYYY,
    SELECT_COUNTRY,
    CHINESE_SIMPLIFIED_CHINESE,
    DUTCH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    MANDARIN_TRADITIONAL_CHINESE,
    POLISH,
    PORTUGUESE,
    SPANISH,
    THAI,
    TURKISH,
    VIETNAMESE,
    BROWSE,
    FEEDBACK_SUBMITTED,
    YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
    IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
    CLOSE,
    PATIENT_AGE,
    ENTER_AGE,
    PATIENT_DOB,
    RELEVANT_ATTACHMENTS,
    VANTIVE_ACCOUNT_CREDENTIALS,
    GET_PRODUCT_DETAILS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_2,
    FACILITY_ADDRESS,
    LABEL_ANOTHER_FACILITY_ADDRESS,
    CHOOSE_PRODUCT_CODE,
    PRIVACY_NOTICE,
    DECLINE,
    OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
    OPTION_COUNTRYOPTIONS_CURAÇAO,
    OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
    OPTION_COUNTRYOPTIONS_ESWATINI,
    FORM_HELP_TEXT,
    YOUR_FIRST_NAME,
    YOUR_LAST_NAME,
    MY_FIRST_NAME,
    MY_LAST_NAME,
    PATIENT_FIRST_NAME,
    PATIENT_LAST_NAME,
    REPORTER_FIRST_NAME,
    REPORTER_LAST_NAME,
    EMPLOYEE_FIRST_NAME,
    EMPLOYEE_LAST_NAME,
    END_USER_CUSTOMER_FIRST_NAME,
    END_USER_CUSTOMER_LAST_NAME,
    ADDITIONAL_CONTACT_FIRST_NAME,
    ADDITIONAL_CONTACT_LAST_NAME,
    COPYRIGHT_VANTIVE,
    COPYRIGHT_VERSION,
    ADD_ADDITIONAL_CONTACT,
    CONTACT_ME,
    DO_NOT_CONTACT,
    END_USER_CUSTOMER_FACILITY_NAME,
    END_USER_CUSTOMER_PHONE,
    END_USER_CUSTOMER_EMAIL,
    END_USER_CUSTOMER_FACILITY_ADDRESS,
    SAME_AS_PATIENT_ADDRESS,
    SAME_AS_REPORTER_ADDRESS,
    SAME_AS_END_USER_CUSTOMER_ADDRESS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_3,
    CONTACT_US,
    LANDING_BRIEF_FOR_DEVICE,
    PATIENT_SEX,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
    ATTENTION_NEEDED,
    SUBMIT_ERR_MSG,
    SUBMIT_RETRY_MSG,
    OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "產品回饋通報平台";
translations[LANDING_BRIEF] = "此Vantive產品回饋通報平台用以送出保密資訊與Vantive產品回饋";
translations[LANDING_LANGUAGE_SELECTOR] = "選擇語言偏好";
translations[LANDING_COUNTRY_SELECTOR] = "選擇事件發生國家";
translations[LANDING_TERMS] = "我已閱讀並同意Vantive產品回饋通報介面的使用條款和隱私聲明";
translations[LANDING_TERMS_ERROR] = "您必須閱讀並同意Vantive產品回饋通報介面的使用條款、隱私聲明、Vantive產品回饋通報補充使用條款和隱私聲明的內容";
translations[LANDING_CAPTCHA_ERROR] = "請確認您非機器人";
translations[APP_DESCRIPTION] = "此Vantive產品回饋通報平台用以送出產品資訊。若您有任何Vantive產品相關問題，請您提供完整詳細資訊。您的回饋將幫助我們持續改善並加強產品滿意度，對我們十分重要。";
translations[LANDING_TERMS_I_HAVE_READ] = "我已閱讀 Vantive 產品反饋門戶網站的鏈接隱私聲明，並了解 Vantive Corporation（“Vantive”）正在徵求我的同意，以便出於隱私聲明中所述的目的和目的使用、披露和處理我的個人數據。我在此同意：";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "出於隱私聲明中所述目的使用、披露、存儲和處理我的個人數據（包括我選擇提供的任何敏感數據，例如健康相關數據）。";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "將我的個人數據（包括我選擇提供的敏感數據，例如與健康相關的數據）從我的國家轉移到另一個可能不那麼嚴格或沒有數據保護法律的國家。";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "我了解此同意是自願的，我可以隨時改變主意並通過使用隱私聲明中提供的聯繫方式聯繫Vantive來撤銷我的同意。我明白撤回我的同意不會影響撤回前處理的合法性。";
translations[MENU_FEEDBACK_FORM] = "開始產品回饋通報";
translations[MENU_FEEDBACK_STATUS] = "確認產品回饋通報狀態";
translations[MENU_FORM_INTAKE] = "通報者/聯絡方式";
translations[MENU_FORM_EVENT_DETAILS] = "事件詳情";
translations[MENU_FORM_PRODUCT_INFO] = "通報產品資訊";
translations[SYSTEM_FEEDBACK_FORM] = "開始填寫產品回饋通報表";
translations[SYSTEM_FEEDBACK_STATUS] = "確認產品回饋狀態";
translations[SUBMIT_FEEDBACK] = "按此送出產品回饋";
translations[CHECK_SUBMITTED_FEEDBACK] = "按此確認先前送出產品回饋狀態";
translations[BTN_LAUNCH_FORM] = "連結表單";
translations[BTN_CHECK_STATUS] = "確認狀態";
translations[FORM_TITLE] = "產品回饋通報表";
translations[FORM_SUB_TITLE] = "若有多數病患，請為每位病患分別填寫投訴通報";
translations[FORM_MANDATORY_FIELDS] = "所有帶 * 的欄位均為必填";
translations[BUTTON_PREV] = "回到前一頁";
translations[BUTTON_NEXT] = "下一步";
translations[BUTTON_SUBMIT] = "送出";
translations[SELECT_RESPONSE] = "選擇回應";
translations[FUNCTION_ROLE] = "單位/職稱";
translations[CUSTOMER_ACCOUNT_NUMBER] = "客戶帳號";
translations[ENTER_CUSTOMER_ACCOUNT] = "請輸入客戶帳戶";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "通報事件中客戶的Vantive帳號";
translations[EVENT_REPORTED] = "此案是否已通報 (給Vantive或其它單位)";
translations[REFERENCE_NUMBER] = "此事件相關的參考編號";
translations[ENTER_REFERENCE] = "請輸入通報編號";
translations[WHO_REPORTED_TO] = "您曾通報的對象";
translations[WHO_WAS_NOTIFIED] = "通報對象的姓名?";
translations[ENTER_NAME] = "請輸入名字";
translations[YOUR_NAME] = "您的姓名";
translations[OCCUPATION] = "職業 (職稱)";
translations[PHONE_NUMBER] = "連絡電話";
translations[ENTER_PHONE_NUMBER] = "請輸入連絡電話";
translations[ENTER_EMAIL] = "請輸入電子郵件";
translations[EMAIL_ADDRESS] = "電子郵件地址";
translations[ENTER_ADDRESS] = "請輸入電郵地址";
translations[ENTER_NA_IF_UNKNOWN] = "若無法得知請輸入'NA'";
translations[FACILITY_HOSPITAL] = "院所/醫院或經銷商名稱（如適用）";
translations[ENTER_FACILITY] = "請輸入院所名稱";
translations[ADDRESS_1] = "地址列 1";
translations[ADDRESS_2] = "地址列 2";
translations[CITY] = "城市";
translations[STATE] = "州";
translations[POSTAL_CODE] = "郵遞區號";
translations[COUNTRY] = "國家";
translations[END_USER_CUSTOMER] = "是否為使用者/客戶發現此問題？";
translations[ADDITIONAL_CONTACT_PERSON] = "其他聯絡人";
translations[ADDITIONAL_PHONE] = "其他聯絡電話號碼";
translations[ADDITIONAL_EMAIL] = "其他聯絡電子郵件";
translations[ANOTHER_FACILITY_ADDRESS] = "添加另一個院所/地址";
translations[ANOTHER_FACILITY_HOSPITAL] = "其他院所/醫院或經銷商名稱（如適用）";
translations[ANOTHER_ENTER_FACILITY] = "請輸入院所名稱";
translations[ANOTHER_ADDRESS_1] = "地址列 1";
translations[ANOTHER_ADDRESS_2] = "地址列 2";
translations[ANOTHER_CITY] = "城市";
translations[ANOTHER_STATE] = "州";
translations[ANOTHER_POSTAL_CODE] = "郵遞區號";
translations[ANOTHER_COUNTRY] = "國家";
translations[LOT_SERIAL_NUMBER] = "批號/序號";
translations[ENTER_LOT_SERIAL_NUMBER] = "請輸入批號/序號";
translations[HELP_LOT_SERIAL_NUMBER] = "若無法得知產品批號或序號，請輸入'Unknown'; 若您已詢問通報者且無法得知，請鍵入'asked but unknown'";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "產品代碼";
translations[PRODUCT_CODE] = "產品代碼";
translations[ENTER_PRODUCT_CODE] = "請輸入產品代碼";
translations[HELP_PRODUCT_CODE] = "若無法得知產品代碼，請輸入'Unknown', 若您已詢問通報者且無法得知，請鍵入'asked but unknown'";
translations[NDC] = "國家藥品代碼 (NDC) 編號";
translations[ENTER_NDC] = "請輸入國家藥品代碼 (NDC) ";
translations[UDI] = "醫療器材單一識別碼 (UDI)";
translations[ENTER_UDI] = "請輸入醫療器材單一識別碼 (UDI)";
translations[PRODUCT_NAME] = "產品名稱";
translations[ENTER_PRODUCT_NAME] = "請輸入產品名稱";
translations[HELP_PRODUCT_NAME] = "提供產品名稱或是產品描述";
translations[BEST_DESCRIBES] = "請選擇最能描述所報告問題的選項";
translations[QUANTITY_TO_SELECT] = "選擇數量";
translations[ENTER_QUANTITY] = "請輸入數量";
translations[HELP_QUANTITY] = "通報問題產品的數量";
translations[UNIT] = "單位";
translations[AVAILABLE_TO_RETURNED] = "通報問題的實際產品是否可以退回Vantive進行評估？";
translations[PHOTOGRAPH_AVAILABLE] = "是否可提供產品的照片或影片？";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "確認通報問題可見於提供之照片或影片";
translations[UPLOAD_IMAGES] = "上傳圖片";
translations[REPORTER_NAME] = "通報人姓名";
translations[REPORTER_FACILITY] = "通報人單位";
translations[REPORTER_OCCUPATION] = "通報人職業";
translations[ENTER_NUMBER] = "請輸入編號";
translations[REPORTER_PHONE_NUMBER] = "通報人連絡電話";
translations[REPORTER_EMAIL_ADDRESS] = "通報人電子郵件地址";
translations[EMPLOYEE_NAME] = "員工姓名";
translations[EMPLOYEE_PHONE_NUMBER] = "員工連絡電話";
translations[EMPLOYEE_EMAIL_ADDRESS] = "員工電子郵件地址";
translations[RETURNING_FOR_INVESTIGATION] = "有多少報告問題的樣品（以個為單位）可退回進行調查？";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "樣品應為通報問題之產品";
translations[UNUSED_VANTIVE_PRODUCT] = "同一批次中是否有未使用的Vantive產品可退回Vantive進行評估？";
translations[YOU_INDICATED_SAMPLES] = "您告知有樣品可供評估，您能否將這些樣品帶給您的醫療院所呢?";
translations[SAMPLE_RETURN_KIT] = "您告知有樣品可供評估，請確認您提供地址以利寄送樣品退運組：";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "預付運費的盒子會送到此地址以退回通報產品";
translations[SAME_AS_MY_ADDRESS] = "同我的地址";
translations[OTHER_CONTACT_NAME] = "其他聯絡人姓名";
translations[OTHER_CONTACT_OCCUPATION] = "其他聯絡人的職業";
translations[OTHER_CONTACT_PHONE_NUMBER] = "其他聯絡人電話號碼(連絡電話)";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "其他聯絡人的電子郵件地址";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "您選擇的產品是由另一家公司(委外工廠)生產的，如果他們對您的產品回饋通報有其他問題，我們可以向他們提供您的聯繫方式嗎？";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "客戶是否明確要求調查結果？";
translations[EXPLICITLY_REQUEST_CREDIT] = "客戶是否明確要求補貨？";
translations[PRODUCT_FROM_VANTIVE] = "客戶是否直接從Vantive訂購產品？";
translations[QUANTITY_REQUESTED_CREDIT] = "申請補貨的批號和數量：";
translations[ENTER_OCCUPATION] = "請輸入職業";
translations[LOT_QUANTITY_NUMBER] = "請輸入批號和數量";
translations[WHOLESALERS_NAME] = "經銷商的名稱和地址是什麼（城市、州）";
translations[PLACE_WHOLESALERS_NAME] = "經銷商的名稱和地址是什麼（城市、州）";
translations[ADD_PRODUCT_TO_THE_GRID] = "新增通報產品";
translations[SAVE] = "儲存";
translations[CANCEL] = "取消";
translations[ADD_MORE_PRODUCTS] = "添加更多產品";
translations[REPORTER_ADDRESS] = "通報人地址";
translations[ATTACHMENTS] = "附件";
translations[DATE_OF_EVENT] = "事件發生日";
translations[DATE_OF_EVENT_MSG] = "事件日期不能晚於第一次通知Vantive員工的日期。請輸入一個有效的日期。";
translations[HELP_DATE_OF_EVENT] = "如果事件發生於多個已知日期，請為每個日期填寫一份表格。";
translations[DATE_VANTIVE_EMPLOYEE] = "首次通知Vantive員工的日期";
translations[DURING_WHAT_PROCESS] = "事件發生在哪些流程步驟中？";
translations[WAS_THE_PATIENT] = "病患在事件發生時是否已連接（正在進行治療）？";
translations[WERE_YOU_CONNECTED] = "事件發生時是否連接Vantive產品(治療中)";
translations[PROVIDE_ANY_ADDITIONAL] = "提供與事件/問題相關的任何其他詳細資訊";
translations[HELP_YOU_IDENTIFIED_MORE] = "若您發現了不止一種的產品和問題，請說明各別產品分別有何種問題。";
translations[ENTER_DETAILS] = "請輸入詳細資訊";
translations[PROVIDE_ANY_ATTACHMENT] = "提供任何適用的附件";
translations[WAS_NEGATIVE_MEDICAL] = "該事件是否有任何負面的醫療影響、症狀或傷害？";
translations[WAS_MEDICAL_INTERVENTION] = "是否提供治療、醫療介入或提升照顧以減緩報告的事件？";
translations[PROVIDE_DETAILS] = "提供詳細資訊";
translations[REQUIRED_TREATMENT] = "所需的治療/醫療介入";
translations[ENTER_TREATMENT] = "請輸入治療";
translations[RELEVANT_TESTS] = "相關測試包括實驗室數據：";
translations[HELP_RELEVANT_TESTS] = "請輸入相關檢驗";
translations[RELEVANT_MEDICAL_HISTORY] = "相關病史，包括既往病史：";
translations[ENTER_HISTORY] = "請輸入病史";
translations[PATIENT_NAME] = "病患姓名";
translations[PATIENT_INITIALS] = "病患的縮寫或全名。若有多數病患，請為每位病患分別填寫投訴通報";
translations[PATIENT_PHONE_NUMBER] = "病患連絡電話";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "不願提供資料";
translations[PATIENT_EMAIL_ADDRESS] = "病患電子郵件地址";
translations[PATIENT_ADDRESS] = "病患地址";
translations[SAME_ADDRESS] = "相同地址";
translations[DRUG_BEING_USED] = "事件發生時是否使用了Vantive藥物？";
translations[PATIENT_IDENTIFIER] = "病患ID";
translations[PATIENT_AGE_OR_DOB] = "患者年齡或出生日期";
translations[ENTER_PATIENT_AGE] = "請輸入生日(月份/日期/西元年)，或請輸入患者年齡";
translations[PATIENT_GENDER] = "病患性別";
translations[PATIENT_WEIGHT] = "病患體重";
translations[ENTER_WEIGHT] = "請輸入體重";
translations[PATIENT_WEIGHT_UNIT] = "病患體重單位";
translations[MY_NAME] = "我的 姓名";
translations[ENTER_IN_YOUR_CONTACT] = "請輸入您的聯絡方式";
translations[MY_PHONE_NUMBER] = "我的連絡電話";
translations[MY_EMAIL_ADDRESS] = "我的電子郵箱";
translations[MY_ADDRESS] = "我的地址";
translations[NAME_OF_VANTIVE_DRUG] = "Vantive藥品名稱";
translations[ENTER_DRUG_NAME] = "請輸入藥品名稱";
translations[PLEASE_PROVIDE_THE_NAME] = "請提供Vantive藥物的名稱或產品代碼。提供報告問題時正在使用的所有Vantive藥物的名稱";
translations[SELECT_THE_COMPONENT] = "選擇有問題的零件";
translations[USE_THE_DIAGRAM] = "使用上圖（圖 1）確定損壞的一次性用品的位置。";
translations[TYPE_OF_DAMAGE] = "請描述損壞種類";
translations[PLEASE_ENTER_VALUE] = "請輸入值";
translations[WAS_THE_PRODUCT_KINKED] = "產品是扭曲、破裂、彎折、切割等？";
translations[WERE_ANY_CLEANING] = "產品上是否使用了任何清潔溶液、溶劑或消毒劑？";
translations[WHAT_WAS_THE_DISINFECTANT] = "消毒劑的名稱/品牌是什麼，如何使用？";
translations[NOTE_VANTIVE_LABELING] = "Vantive標籤說明不使用漂白劑、過氧化氫、酒精或含有酒精的防腐劑。使用這些產品會導致產品出現裂損";
translations[SELECT_ALL_THAT_APPLY] = "選擇所有符合條件的";
translations[DID_FOLLOWING_OCCUR] = "是否發生了以下任何情況？";
translations[SELECT_THE_LOCATION] = "選擇迷你帽上有損壞的位置";
translations[WAS_THE_PRODUCT_EXPOSED] = "在問題發生之前，產品是否受到過大的力量衝擊（像是撞，顛，打擊等）？";
translations[HOW_LONG_TRANSFER] = "輸液管組已使用多長時間？";
translations[WAS_THERE_DIFFICULTY] = "打開或關閉旋轉接頭時是否有任何困難？";
translations[WAS_DEVICE_OR_TOOL] = "是否使用了任何裝置或工具來打開或關閉旋轉接頭？";
translations[DESCRIBE_HOW_PRODUCT] = "描述產品如何難以使用（選擇所有適用項目）";
translations[DID_YOU_OBSERVE] = "您是否觀察到產品有任何損壞（例如切割，孔洞，裂縫）？";
translations[WERE_DIFFICULTIES_PUTTING] = "將迷你帽放在輸液管組上並順時針旋轉直到牢固固定之前，是否有任何困難？";
translations[WAS_THE_TRANSFER] = "輸液管組是否由於此事件而更換？";
translations[SELECT_TYPE_OF_FLOW] = "選擇輸注問題的類型";
translations[WAS_ANYTHING_BLOCKING] = "是否有東西阻塞輸注？";
translations[WAS_ANY_ALARM] = "是否有任何警報？";
translations[SELECT_BEST_DESCRIBE] = "請選擇最能精確描述問題的選項";
translations[WERE_THE_MINICAPS] = "迷你帽是否暴露或儲存在熱/冷環境中？";
translations[WAS_THE_SPONGE_VISIBLE] = "海綿在迷你帽內可見嗎？";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "顆粒物/異物位於何處？";
translations[DESCRIBE_THE_EXACT_LOCATION] = "描述顆粒物/異物的確切位置，大小，形狀和顏色：";
translations[WAS_THE_PARTICULATE_MATTER] = "產品中是否嵌入了顆粒物/異物？";
translations[DOES_THE_PARTICULATE_MATER] = "顆粒材料/異物是否看起來像產品材料的碎片？";
translations[WHAT_COMPONENT_DOES] = "顆粒物看起來像來自什麼零件？";
translations[SELECT_CONNECTION_ISSUE] = "選擇最能描述連接問題的選項";
translations[WERE_ASSIST_DEVICES] = "是否有任何輔助設備或工具用於進行一次性連接？";
translations[WERE_ANY_DIFFICULTIES] = "在初始連接期間或斷開連接時，是否感到困難？";
translations[PROVIDE_PRODUCT_INFORMATION] = "提供連接問題中所涉及到其他產品的產品資訊";
translations[WERE_THE_SPIKE_LUER] = "穿刺/魯爾鎖接頭是否能以順時針旋轉，直到它們牢固固定？";
translations[VANTIVE_LABELING_STATES] = "Vantive標籤聲明確保所有一次性使用產品的連接在開始治療前都牢固且適當。";
translations[WERE_PETS_OR_ANIMALS] = "是否有任何寵物或動物可能會損壞一次性套組？";
translations[VANTIVE_LABELING_CONTAMINATION] = "Vantive標籤指出，如果寵物或動物咬了一次性用品，可能會導致流體通道受到污染。為降低這種風險，請勿與寵物或動物在同一個房間進行透析。";
translations[WERE_OTHER_ISSUES] = "是否有任何與穿刺/魯爾接頭相關的其他問題或困難（即破裂，變形，彎曲等）？";
translations[WAS_MINICAP_TWISTED] = "迷你帽是否能以順時針方向擰到輸液管組上，直到牢固固定？";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "將迷你帽接到輸液管組上是否有任何困難？";
translations[DID_TRANSFER_SET_CONNECTORS] = "輸液管組的螺紋上是否有任何可見的損壞或殘留物？";
translations[WHAT_WAS_THE_ALARM] = "警報顯示的內容為何?　";
translations[WHERE_OBSERVED_DAMAGE] = "觀察到的損壞在哪裡（選擇所有適用項）？";
translations[SELECT_THE_TYPE_OBSERVED] = "選擇觀察到的損壞類型（選擇所有適用項）：";
translations[DID_DAMAGE_CAUSE_LEAK] = "損壞是否導致漏液？";
translations[WAS_THE_SHIPPING_CARTON] = "裝運紙箱是用尖銳的物體打開的嗎？";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "選擇觀察到的輸注問題類型";
translations[HOW_LONG_WAS_STORAGE] = "在發現產品過期時，產品已儲存了多長時間？";
translations[WAS_THERE_AN_ADAPTER] = "產品是否使用了轉接器或任何其他設備？";
translations[NAME_AND_MODEL] = "轉接器或使用的任何其他設備的名稱和型號是什麼？";
translations[NAME_VAPORIZER] = "噴霧器的名稱和型號是什麼？";
translations[WAS_VIAL_INVERTED] = "在將溶液裝到瓶子前，所附的瓶子是否倒置？";
translations[WHAT_VIAL_USED] = "所使用瓶子的產品資訊是什麼？";
translations[DRUG_NAME_MANUFACTURER] = "藥物名稱、製造商、藥瓶大小";
translations[WERE_BREAK_FRANGIBLE] = "您是否能夠正確透過反覆凹折打破易折部位？";
translations[WAS_ALARM_ASSOCIATED] = "是否有任何與無流速相關的警報？";
translations[WHAT_PART_DISCOLORED] = "產品的哪個部分通報變色？（選擇所有適用項目）";
translations[DESCRIBE_DISCOLORATION] = "描述變色（描述顏色，色調，色調，陰影等）：";
translations[HOW_PRODUCT_STORED] = "產品是如何儲存的？";
translations[DOES_DISCOLORATION_APPEAR] = "變色是否看起來不透明，朦朧，渾濁和/或有圓形/蜜梳狀標記？";
translations[WHICH_CHAMBER_DISCOLORED] = "袋子上的哪個腔室變色了？";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "易撕封條或腔室堅易撕物是否已經破損/混合？";
translations[WAS_DISCOLORATION_NOTICED] = "是否通過噴霧器觀察鏡注意到變色？";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "選擇更具體地描述問題的選項：";
translations[WHAT_DEVICE_HAD_ALARM] = "什麼設備有警報？";
translations[WHAT_MISSING_MISASSEMBLED] = "哪個零件不見或組裝錯誤？";
translations[RECONSTITUTION_ISSUE] = "提供混合問題的更具體描述";
translations[WHAT_MEDICATION_SOLUTION] = "產品用什麼藥物/溶液混合？";
translations[WHAT_VOLUME_MEDICATION] = "用於混合的藥物/溶液的量是多少？";
translations[WHAT_DEVICES_RECONSTITUTION] = "在混合過程中使用了哪些其他設備（名稱/製造商，針尺寸/規格等）";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "產品是否暴露在高溫下？";
translations[DESCRIBE_EXPOSURE] = "描述暴露（溫度、持續時間等）";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "使用什麼技術來混和溶液？";
translations[WAS_DAMAGE_OBSERVED] = "在混合之前，產品是否受到任何損壞？";
translations[DESCRIBE_THE_DAMAGE] = "描述損壞：";
translations[APPROXIMATELY_SOLUTION_POWDER] = "大約，有多少溶液或粉末填充不足或過度填充？";
translations[WAS_LEAK_OBSERVED] = "是否觀察到任何(洩)漏液？";
translations[WHAT_FEATUR_DIFFICULT_USE] = "產品的哪些部分或功能難以使用？";
translations[HOW_WAS_DIFFICULT_USE] = "產品如何難以使用？";
translations[WHERE_MATTER_FOREIGN] = "顆粒物/異物位於何處？";
translations[DOES_PARTICULATE_MATTER] = "顆粒物/異物是否看起來像是產品材質？";
translations[DESCRIBE_EXACT_LOCATION] = "描述顆粒物/異物的確切位置，顏色，大小，形狀和質地：";
translations[WAS_MATTER_FOREIGN] = "顆粒物/異物是否嵌入到產品中（不能自由移動）？";
translations[WHEN_MATTER_FOREIGN] = "何時觀察到顆粒物/異物？";
translations[PROVIDE_INFORMATION_MEDICATION] = "提供添加的藥物的產品資訊：";
translations[PRODUCT_NAME_CODE_NUMBER] = "產品名稱、產品代碼、產品批號、品牌名稱";
translations[DESCRIBE_SPIKING] = "描述所使用的穿刺或混合技術：";
translations[INCLUDE_NEEDLE] = "包括針頭尺寸/規格、尖刺/穿刺角度、嘗試次數";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "使用了什麼給藥或混合裝置？";
translations[INCLUDE_MANUFACTURER] = "包括製造商、產品名稱、產品代碼、產品批號";
translations[WAS_MEDICATION_ADDITIVE] = "是否在產品中添加了藥物、添加劑或混合溶液？";
translations[WHAT_MEDICATION_ADDITIVE] = "添加了什麼藥物，添加劑或混合溶液？";
translations[WHAT_STATE_OF_PRODUCT] = "當觀察到混濁/沉澱物時，產品的狀態如何？";
translations[AFTER_UNITS_SAT] = "在產品達到室溫後，混濁/沉澱物是否消失了？";
translations[DID_ATTEMPT_AGITATE] = "您是否有試圖混合產品？";
translations[DID_PRECIPITATE_DISSOLVE] = "沉澱物溶解了嗎？";
translations[WHAT_STORAGE_TEMPERATURE] = "產品的儲存溫度和條件是什麼？";
translations[PROVIDE_TEMPERATURE_LOCATION] = "提供溫度、位置、儲存在外包裝袋/紙箱內部或外部、在 VSC/中間紙箱中、各別的單位";
translations[ARE_TEMPERATURE_LOGS] = "產品儲存的冷藏環境是否有溫度紀錄？";
translations[LOGS_CAN_BE_ATTACHED] = "機器記錄檔可以直接附加到此表單（如果在提交時可取得）";
translations[IS_THE_STORAGE_UNIT] = "儲存設備（冷凍室或冰箱）是否經過校正和溫度控制？";
translations[HOW_PRODUCT_THAWED] = "產品是如何解凍的？";
translations[WHAT_STORAGE_CONDITIONS] = "產品的儲存條件是什麼？（溫度、位置、儲存在外包裝袋/紙箱內或外）";
translations[WAS_ANY_DAMAGE] = "是否觀察到產品有任何損壞或問題？";
translations[MORE_SPECIFIC_INFORMATION] = "請提供更具體的資訊：";
translations[WHAT_PURPOSE_INDICATION] = "患者的治療目的/適應症是什麼？";
translations[WHAT_ROUTE_ADMINISTRATION] = "執行方式是什麼？";
translations[WHAT_DATE_ADMINISTRATION] = "執行日期和持續時間是什麼時候？";
translations[WHAT_DOSAGE_STRENGTH] = "給予患者的劑量/強度是多少？";
translations[WAS_RECENT_PRESCRIPTION] = "最近是否有處方變化？";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "產品的儲存/溫度細節是什麼（儲存位置/冰箱/冰櫃等）？";
translations[WERE_ANY_ADJUSTMENTS] = "在給藥前，溶液或添加劑是否有任何調整？";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "選擇最合適的問題描述：";
translations[SELECT_LABELING_ISSUE] = "選擇最合適的標籤問題描述：";
translations[WAS_CONNECTION_SECURE] = "連接是否安全且完全拴緊？";
translations[WAS_EXPIRED_PRODUCT] = "過期的產品是否給患者服用？";
translations[WAS_COMPONENT_DAMAGED] = "是否有任何零件損壞？";
translations[WERE_ABNORMALITIES_DAMAGE] = "產品是否有任何異常/損壞？";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "您的採購訂單編號是多少？";
translations[WHAT_DATE_OF_ADMINISTRATION] = "執行日期是什麼時候？";
translations[WHAT_WAS_EXPIRATION_DATE] = "產品的有效期是什麼時候？";
translations[DESCRIBE_WAS_INCORRECT] = "描述標籤上不正確、不完整、缺失、難以辨認的內容或標籤上的內容（與其他商品）過於相似：";
translations[WHAT_SCANNER_USED] = "使用了什麼類型的掃描器？";
translations[WAS_OVERPOUCH_POUCH] = "掃描時，產品是否仍在外袋/袋中？";
translations[WHAT_BACKGROUND_COLOR] = "掃描時的背景顏色是什麼？";
translations[DO_ALL_OF_THE_LABELS] = "是否所有標籤（產品、包裝盒/紙箱、運輸/配送）都具有相同的產品資訊？";
translations[PRODUCT_INFORMATION] = "通報產品資訊";
translations[IS_A_BARCODE_SCANNER] = "您的單位是否使用條碼掃描器？";
translations[HOW_ARE_THESE_PRODUCTS] = "這些產品如何儲存在設施中？";
translations[WHAT_INFORMATION_INCORRECTLY] = "在掃描時顯示哪些錯誤的資訊？";
translations[WAS_THERE_LEAK] = "是否觀察到洩漏或潮濕？";
translations[WHERE_LEAK_OBSERVED] = "在哪裡觀察到洩漏，什麼零件洩漏？";
translations[WAS_FRANGIBLE_OBSERVED] = "觀察到易破壞的部分損毀了嗎？";
translations[IS_MOISTURE_CLEAR] = "水份是否透明？";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "你們的經銷商是？";
translations[WHAT_MANUFACTURER_MEDICATION] = "製造商，藥物名稱和所用小瓶的大小是多少？";
translations[WHAT_GAUGE_NEEDLE] = "使用的穿刺針的規格，製造商和現場被刺穿的次數是多少？";
translations[WHAT_ADMINISTRATION_SET] = "使用了什麼執行工具？";
translations[WAS_DIFFICULTY_SPIKING] = "穿刺有困難嗎？";
translations[WERE_FOLLOWING_SCENARIOS] = "洩漏的同時是否發生了以下敘述的情況？";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "是否觀察到易碎部分有損壞或缺陷？";
translations[WHAT_AMOUNT_PRESSURE] = "施加了多少壓力，持續時間是多少？";
translations[WAS_BAG_COMPLETELY] = "袋子是否完全正確地插入了壓力袖帶（一端是否在壓力袖帶之外）？";
translations[WHAT_MANUFACTURER_MODEL] = "壓力袖帶的製造商，型號和尺寸是什麼？";
translations[WHAT_PRESSURE_PRIOR] = "偵測到洩漏之前的壓力是多少？";
translations[LIST_THE_VAPORIZER] = "列出噴霧器製造商和名稱/型號";
translations[APPROXIMATELY_HOW_MUCH] = "大約有多少液體溢出？";
translations[WAS_THE_BOTTLE_DIFFICULT] = "瓶子是否難以插入噴霧器？";
translations[WERE_VISIBLE_DEFECTS] = "是否有任何可見的缺陷？";
translations[SELECT_THE_OPTION] = "選擇最能描述連接問題的選項";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "提供連接問題中所涉及到其他產品的產品資訊";
translations[WHICH_PART_SEPARATED] = "產品的哪些部分被分離？";
translations[WHAT_COMPONENT_DISCOLORED] = "什麼零件變色？";
translations[SELECT_DESCRIBES_DISCOLORATION] = "選擇最能描述變色的選項：";
translations[WAS_THE_SET_DISCOLORED] = "從包裝中取出套組時是否變色？";
translations[DID_SET_CHANGE_COLOR] = "加藥后，套組是否變色？";
translations[WHAT_MEDICATION_ADDED] = "在顏色改變之前添加了什麼藥物？";
translations[WHERE_MATERIAL_LOCATED] = "顆粒物/異物位於何處？";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "描述顆粒物/異物（外觀/顏色/大小）：";
translations[WAS_EMBEDDED_PLASTIC] = "顆粒物/異物是鬆動的還是嵌入塑膠中的？";
translations[WAS_THERE_A_PRECIPITATE] = "輸注液/溶液是否有未預期的沉澱物或顏色變化？";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "通過套組注入了哪些藥物/溶液？";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "損壞在哪裡或哪些零件受到影響（選擇所有適用項目）？";
translations[WHAT_DAMAGE_ISSUE] = "觀察到了哪種類型的損壞/問題（選擇所有適用項目）？";
translations[DID_ISSUE_RESULT] = "此問題是否會導致洩漏？";
translations[WAS_PATIENT_CONNECTED] = "患者是否連接到產品？";
translations[WAS_PRODUCT_REPLACED] = "產品是否被新品替換？";
translations[WHICH_SITUATION_BEST] = "哪種情況最能描述分離/連接問題";
translations[SELECT_MOST_LABELING_ISSUE] = "選擇最合適的標籤問題描述：";
translations[WHAT_INFORMATION_DISPLAYED] = "顯示了哪些資訊？";
translations[WHAT_SCANNER_WAS_USED] = "使用了什麼類型的掃描器？";
translations[INCLUDE_THE_MODEL_NAME] = "包括型號名稱";
translations[WAS_PRODUCT_ORDERED] = "產品是直接從Vantive還是其他經銷商訂購的？";
translations[WHERE_LEAK_COMING] = "洩漏來自哪裡（選擇所有適用項目）？";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "洩漏是否發生了任何以下情況？";
translations[WAS_POWER_INJECTOR] = "產品是否與加壓輸注器一起使用？";
translations[WHAT_INJECTOR_USED] = "使用了什麼加壓輸注器？";
translations[MANUFACTURER_NAME_CODE_LOT] = "製造商、產品名稱、產品代碼、產品批號";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "描述標籤上不正確、不完整、缺失、難以辨認或更改的內容：";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "提供斷開連接使用的第二個產品資訊";
translations[WHICH_COMPONENTS_WERE_FOUND] = "發現哪些零件有裂縫或斷裂？";
translations[DESCRIBE_CUT_HOLE_SLICE] = "描述管路上具有切口、孔或削的確切位置：";
translations[WAS_LEAK_ORIGINATING] = "是否從注射口洩漏";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "提供斷開連接/連接問題涉及使用的第二個產品資訊";
translations[WHICH_SPECIFIC_BONDED] = "發現哪些特定的黏合的零件被分離？";
translations[WERE_VISIBLE_IRREGULARITIES] = "所涉及的產品/零件是否有任何明顯的不規則/損壞";
translations[WAS_SUCCESSFUL_CONNECTION] = "是否成功的連接或斷開連接（未更換產品）？";
translations[WAS_TOOL_USED_ASSIST] = "是否使用了工具來協助連接/斷開連接？";
translations[WERE_LUER_CONNECTIONS] = "是否檢查了所有魯爾連接，確保它們在使用前是牢固的（每個包裝）";
translations[WAS_PRODUCT_SECURELY] = "在斷開連接之前，產品是否與其他產品牢固連接？";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "哪種情況最能描述輸注問題？";
translations[WHAT_FLOWING_BACKWARDS] = "什麼在逆流？";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "描述從逆流開始到停止的結構：描述逆流從開始到結束的結構位置";
translations[DO_SITUATIONS_APPLY] = "以下情況是否適用於此事件？";
translations[WHICH_SPECIFIC_AREA] = "套組或零件的哪個特定部位與輸注問題相關聯？";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "以前是否透過套組或零件觀察到流動？";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "是否觀察到以下任何一項：";
translations[WHERE_SIMULTANEOUS_FLOW] = "兩者之間的同時流動在哪裡?";
translations[WHAT_TYPE_HANGER] = "使用了什麼類型的掛勾？";
translations[WHAT_WAS_HANGER_LENGTH] = "掛勾的長度和/或製造商是？";
translations[WHICH_BAG_LOWER] = "哪個袋子較低？";
translations[WHAT_Y_SITE_WAS] = "備用套組連接到哪個 y 接頭？";
translations[WHAT_COMPONENT_WITHIN] = "套組中的哪個成分無法清除溶液或血液？";
translations[WAS_COMPONENT_SET_REPLACED] = "在無法清除後零件/套組是否被更換？";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "要輸給患者的液體量和規定的時間段是多少？";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "在什麼時間內，患者實際輸注的液體量是多少？";
translations[WAS_USED_WITH_PUMP] = "該套組是否與幫浦一起使用？";
translations[DID_CLAMP_FAIL] = "夾具是否無法停止或控制流量？";
translations[WHAT_CLAMP_FAILED] = "什麼夾具有問題？";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "夾具上是否觀察到任何狀況？";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "這些其他情況是否說明了產品問題（選擇所有適用的情況）？";
translations[DESCRIBE_ALARM_OBSERVED] = "說明觀察到的警報：";
translations[INCLUDE_ANY_MESSAGES] = "包括與警報相關的任何消息和錯誤代碼";
translations[WHICH_CLAMP_HAD_ISSUE] = "哪個夾具有問題？";
translations[WHICH_TYPE_CLAMP_ISSUE] = "遇到哪種類型的夾具問題（選擇所有適用項目）？";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "選擇最能描述問題的敘述：";
translations[PROVIDE_MORE_DETAILS] = "提供有關產品如何難以使用的更詳細資訊：";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "提供使用說明難以遵循/理解的更詳細資訊：";
translations[DESCRIBE_THE_SMELL] = "描述氣味及其來源：";
translations[WAS_ISSUES_WITH_SET] = "該套組是否觀察到任何問題？";
translations[WHERE_LEAK_LOCATED] = "洩漏位於產品上的哪個位置？";
translations[DID_OCCUR_WITH_LEAK] = "洩漏是否發生以下情況？";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "提供斷開連接使用的第二個產品資訊";
translations[DID_OCCURRED_WITH_THE_LEAK] = "洩漏是否發生了任何以下情況？";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "產品在哪裡損壞？";
translations[SELECT_ALL_APPLY] = "選擇所有符合條件的";
translations[DESCRIBE_OBSERVED_DAMAGE] = "描述觀察到的損壞";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "產品的哪個部分變色了？";
translations[DESCRIBE_HUE_TINT_SHADE] = "描述觀察到的顏色（色調、色調、陰影等）：";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "外包裝袋的內/外部、溫度、光照等。";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "描述顆粒物/異物的確切位置，大小，形狀和顏色：";
translations[DOES_THE_PARTICULATE_MATTER] = "顆粒物/異物是否顯示為產品材質？";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "顆粒物/異物是否嵌入其中？";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "顆粒材料/異物是否看起來像產品材料的碎片？";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "問題出現在產品上的什麼位置？";
translations[LIST_COMPONENTS_IF] = "列出零件。如果涉及第二個產品，請提供製造商、產品名稱、產品代碼、產品批次";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "是否觀察到任何明顯的異常/損壞？";
translations[SELECT_OPTION_FLOW_ISSUE] = "選擇最能描述輸注問題的選項";
translations[DESCRIBE_IRREGULARITIES] = "描述異常/損壞以及是否在連接/分離之前觀察到，或於連接/分離時發生";
translations[HOW_PRODUCT_SETUP] = "產品如何設定？";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "選擇最合適描述標籤問題的選項：";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "描述標籤上不正確、不完整、缺失、難以辨認的內容或標籤上的內容（與其他商品）過於相似：";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "運輸紙箱內的產品是否損壞？";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "應該收到什麼產品？";
translations[IF_PRODUCT_CODE_NOT] = "如果產品代碼無法確認，請提供產品描述";
translations[WAS_THE_CASE_MISSING] = "箱子是否缺少乾冰或冷凝包？";
translations[WHAT_CARRIER_DELIVERED] = "哪個物流商運輸了您的產品？";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "什麼是訂單編號？";
translations[WHAT_QUANTITY_MISSING_UNITS] = "短少數量是多少？";
translations[WAS_EXPIRED_PRODUCT_USE] = "是否使用過期的產品？";
translations[APPLY_TO_EACH_UNIT] = "若有數個產品，以下問題須逐一針對每'單一'產品回覆";
translations[TERMS_CONDITIONS] = "條款和條件";
translations[PRIVACY_POLICY] = "隱私政策";
translations[PRIVACY_NOTICE] = "隱私聲明";
translations[COOKIE_POLICY] = "Cookie 政策”";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "已詢問但未知";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Vantive員工";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "照護者";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "經銷商";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "醫療保健專業人員";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "病患";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "其他";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "使用後";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "使用前";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "設定中/準備中/調劑中";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "治療中";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "多重階段";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "無法確認";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "家庭成員";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "護理師";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "專科護理師";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "其它醫療保健專業人員";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "醫師";
translations[OPTION_UNITOPTIONS_BOXES] = "盒";
translations[OPTION_UNITOPTIONS_PALLETS] = "棧板";
translations[OPTION_UNITOPTIONS_UNITS] = "個";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "警報";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "破損";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "難以使用";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "變色";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "流量問題";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "標籤問題";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "洩漏/過多水分";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "顆粒物/外來異物";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "病患反應/不良事件";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "產品諮詢";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "分離/連接";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "運輸問題/過期產品";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "女";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "無差異化";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "男";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "拒絕回答";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "行政/主管";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "生醫工程師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "公司代表";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "牙醫";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "經銷商";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "家庭成員";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "使用者";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "護理師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "專科護理師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "其它醫療保健專業人員";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "藥師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "藥技生";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "醫師";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "病患";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "風險管理人";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "其它";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "聯絡其它的聯絡人";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "聯絡我";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "聯絡其他人";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "中國FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "歐盟EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "美國FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "加拿大健康部";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "日本PMDA";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV ";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "澳洲TGA";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "寵物或動物可能導致的問題";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "使用鋒利的物體或工具打開紙箱或外包裝袋";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "產品在問題發生之前受到過大的力（即撞擊、碰撞、撞擊等）";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "產品暴露或儲存在熱/冷環境中";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "外箱";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "迷你帽";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "包裝袋";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "輸液管 (Ttransfer Set)太緊了";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "輸液管 (Ttransfer Set)太鬆";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "輸液管 (Ttransfer Set)無法完全關閉";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "輸液管 (Ttransfer Set)無法完全打開";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "旋轉接頭太緊，輸液管 (Ttransfer Set)根本無法打開";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "旋轉接頭太緊，輸液管 (Ttransfer Set)根本無法關閉";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "是 - 輸液管 (Ttransfer Set) 接頭螺紋損壞/出現問題，使其無法正常關閉";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "是 - 手動或使用工具/輔助裝置將迷你帽過度扭緊到輸液管 (Ttransfer Set) ";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "完全停止，沒有流體流動";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "受影響或部分流動（緩慢流動）";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "凝血 (Clotted Blood)";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "纖維 (Fibrin)";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "扭曲";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "顆粒 (Particulate)";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "產品材質";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "在連接或包裝中發現過量的碘（棕色）";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "包裝中發現過多的水分（透明液滴）";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "鋁箔袋在打開前損壞";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "包裝/盒子在使用前打開或損壞";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "海綿變乾變白";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "海綿變乾呈褐色";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "在二次包裝/外包裝";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "在產品/流體路徑內部";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "裝運紙箱內";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "在產品的外面";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "在二次包裝/外包裝袋的外面";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "在運輸紙箱的外部";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "難以將產品連接到另一個產品";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "難以將產品與其他產品斷開連接";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "在單個產品中分離組件";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "產品與其他產品的分離/斷開";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "是- 接頭螺旋處有殘餘";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "是 -有可見之破損";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "是 - 其他（請輸入）";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "易折接頭";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "掛勾孔";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "注射/填充口";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "膜端口";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "外袋/小袋";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "修補";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "橡膠塞";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "運輸紙箱";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "收縮帶";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "液體容器";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "末端保護套";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "防拆標示（收縮包裝）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "彎折";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "破碎";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "破裂";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "切";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "變形";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "剝落";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "洞";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "扭曲";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "融化";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "補丁層分離";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "破碎（玻璃）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "切片";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "撕裂";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "溶液不會流動";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "溶液會非常緩慢地流動";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "在混合過程中，溶液不會流動（或流動緩慢）";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "瓶";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "容器";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "掛勾孔";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "張";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "外袋/小袋";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "氧氣指示劑";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "片";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "端口";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "藥水";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "末端保護套";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "胺基酸腔";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "葡萄糖腔";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "脂肪乳腔";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "下方腔室";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "上方腔室";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "爆裂/破裂的密封";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "組裝錯誤的產品/零件";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "缺少組件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "連接件的分離/斷開";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "產品過滿";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "產品未滿";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "混合問題";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "二次包裝/外包裝";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "運輸紙箱內";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "運輸紙箱的外部";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "內部溶液/液體路徑";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "汽化器內（觀察窗）";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "產品外表面";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "二次包裝/外包裝袋的外面";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "氧氣吸附包";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "在經皮貼劑上";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "易折接頭";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "玻璃顆粒";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "加藥口";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "橡膠塞";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "管路";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "添加另一種藥物後或回溶後（小瓶）";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "在加藥或混合之前";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "低溫 (解凍但未回到室溫)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "結凍";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "部分溶解 (溶液中有冰晶)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "室溫";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Vantive回溫裝置 (VTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "室溫回溫";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "冰箱";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "是 - 有運輸造成的損壞";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "是 - 觀察到洩漏";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "是 - 外包裝袋中有孔或密封不完整";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "是 - 穿刺或混合有困難";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "是 - 打破易折接頭有困難";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "是 - 溶液有結晶或沉澱";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "是 - Frozen Galaxy 產品中有混濁/沉澱";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "產品沒有提供預期的效果或無效（缺乏療效）";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "非預期的影響/反應。 請說明：（請輸入）";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "運輸過程中損壞的運輸紙箱";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "交付過期產品";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "發現過期產品";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "條碼問題 - 掃描時顯示的信息不正確";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "難以掃描/無法掃描條碼";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "交付的過期產品";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "庫存中發現過期產品";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "難以辨認的標籤";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "標籤不正確";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "標籤不完整";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "標籤與其他產品過於相似";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "標籤（產品、盒子/紙箱、運輸清單）沒有相同的產品信息";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "缺少條碼";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "紙箱/盒子包含錯誤產品或混裝產品";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "運輸過程中損壞的紙箱";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "收到了額外的單位";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "交付的過期產品";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "發現過期產品";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "部分紙箱被打開或未密封";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "紙箱和標籤上的產品信息與紙箱內的產品不符";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "單位丟失";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "缺少標籤";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "有效日期";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "批號";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "國家藥品代碼 (NDC) 編號";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "外袋內的液滴/水分，未觀察到洩漏";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "洩漏";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "擠壓袋子時觀察到洩漏";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "流過易折接頭的溶液";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "外包裝袋內的溶液，未觀察到洩漏";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "在外包裝和主容器(藥水袋)之間";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "兩個產品之間的連接";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "容器 - 膜端口/管";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "容器 - 注射/充填端口";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "容器 - 吊掛孔";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "容器";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "易折接頭";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "橡膠塞";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "收縮帶";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "末端保護蓋";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "未知";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "瓶轉接器";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "黏附端口";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "運送箱或內盒的損壞（孔洞、撕裂）";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "暴露於極熱/極冷";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "蒸發器接口處洩漏";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "用開箱刀/鋒利的物體打開運送包裝";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "寵物（抓/咬）";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "以壓力帶或其他裝置對藥水袋加壓";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "粘附端口";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "二次包裝或中間紙箱的損壞（孔洞、撕裂）";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "運輸過程中損壞的運輸紙箱";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "暴露於極熱/極冷";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "蒸發器接口處洩漏";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "用開箱刀/鋒利的物體打開運送紙箱";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "寵物（抓/咬）";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "以壓力帶或其他裝置對藥水袋加壓";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "以上皆非";
translations[NO_DESCRIBE_THE_COLOR] = "否 - 請描述顏色 (輸入)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10 毫升";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "超過 10 毫升(mL)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "小於 1 毫升 (mL)";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "瓶";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "蓋";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "閥/頸部";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "無";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "難以將產品連接到另一個產品";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "難以將產品與其他產品斷開連接";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "在單個產品中分離組件";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "產品與其他產品的分離/斷開";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "滴水室";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "管路";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "其他 - 請說明（請輸入）";
translations[OTHER_PLEASE_SPECIFY] = "其他 - 請說明（請輸入）";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "白色/混濁";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "黃色/棕色";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "其他 - 請說明（請輸入）";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "在初級包裝/泡殼中";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "靜脈輸注( IV)液體路徑中（在管路中）";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "運輸紙箱內";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "運輸紙箱外";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "靜脈輸注( IV)液體路徑外部（管路外部）";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "嵌入";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "鬆散";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "不適用";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "描述顏色（請輸入）";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "是 - 顏色變化";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "是 - 沉澱";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "取樣點";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "滴落管";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "管夾";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "滴水室";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "管路";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "未知";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "過濾器";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "魯爾接頭";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "穿刺接頭";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "切割/破裂/損壞的組件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "不正確的零件裝配 - 請說明（請輸入）";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "扭曲/彎折的組件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "包裝內的鬆散零件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "變形/錯誤形狀的零件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "缺少零件";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "難以將產品連接到另一個產品";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "難以將產品與其他產品斷開連接";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "連接鬆動";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "產品與其他產品的分離/斷開";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "單個產品中兩個連接零件的分離";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "無法將兩個產品連接在一起";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "無法斷開產品與其他產品的連接";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "條碼問題 - 掃描時顯示的信息不正確";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "標籤變更";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "難以掃描/無法掃描條碼";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "產品過期";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "標籤內容不正確";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "缺少產品單一識別碼 (UDI)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "標籤上缺少信息";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "沒有標示效期的產品";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "污損/難以辨識的標籤";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "紙箱/內盒包含錯誤產品或混裝其它產品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "運輸造成的紙箱[損壞";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "交付的過期產品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "發現過期產品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "經銷商";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "收到額外的產品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "部分紙箱被打開或未密封";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "紙箱和運輸標籤上的產品信息與紙箱內的產品不符";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "短少";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "進入點";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "通氣孔 (air vent)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "滴定管";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "蓋";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink 注射點";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "夾";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "滴定室";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "過濾器";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink 注射點";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "魯爾接頭";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "穿刺接頭";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "管路";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "未知";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "注射部位和管路之間的洩漏";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Needle based注射點";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "One-Link 注射點";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "其他注射部位（請輸入）";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "堅硬的零件上有裂紋/斷裂";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "軟管上的割痕/切";
translations[DISCONNECTION_OF_CONNECTABLE] = "可連接組件/連接產品的分離";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "可連接組件/連接產品的分離";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "組合件的分離";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "是 - 請描述異常/損壞 (請輸入)";
translations[YES_SPECIFY_THE_TOOL] = "是- 請說明使用的工具 (請輸入)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "回流";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "夾子失敗 - 難以夾緊（但最終能夠閉合）";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "夾子故障 - 無法完全關閉";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "夾子故障 - 難以打開/無法打開";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "無法流通";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "過度輸液";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "受限制/緩慢流動";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "模擬流通";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "無法移除零件";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "無法充填";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "輸液中";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "病患的血液 (輸注非血液產品)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "藥水/血液製劑";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "洩漏 破損/孔洞";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "連接斷開";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "洩漏";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "通過加壓輸液給予藥物注射器或 靜脈輸注幫浦 (IV pump)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "第二袋低於主袋";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "第二袋與主袋高度相同";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "凝血";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "連接套組前導管未沖洗";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "管路扭曲";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "管路/輸注端阻塞";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "主要和次要容器（搭載輸注）";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "在多套組聯通迴流的套組";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "兩組輸液套，每套都有自己的輸液幫浦 (IV pump)";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Vantive掛勾";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "非Vantive掛勾";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "位於相同高度";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "主要";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "次要";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "中";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "下";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "上";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "是 - 請提供幫浦的產品名與產品型號 (請輸入)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "深藍色滑動夾";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "淺藍色滑動夾";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "夾片";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "滾輪夾";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "白色滑動夾";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "是 - 夾子破裂或受損";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "管路中有氣體";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "管夾問題";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "異味";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "夾片/管路夾";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "滾輪夾";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "滑動夾";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "裂/破損";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "難以打開";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "難以關閉";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "缺少";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "無法打開";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "無法關閉";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "無法控制流量";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "難以擠壓滴注室 (Drip Chamber)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "說明書內容難以遵循/理解";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "產品難以使用";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "裂/破損";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "切割/切片";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "可連接組件/連接產品的分離";
translations[DISCONNECTION_OF_CONNECTABLE] = "可連接組件/連接產品的分離";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "孔/撕裂";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "分離的組件";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "粘附端口";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "二次包裝或中間紙箱的損壞（孔洞、撕裂）";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "運輸過程中損壞的運輸紙箱";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "暴露於極熱/極冷";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "用開箱刀/鋒利的物體打開運送紙箱";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "未知";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "以上皆非";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "使用壓力帶或壓力注射器";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "黏附端口";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "寵物（抓/咀嚼）";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "產品";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "運輸紙箱/箱";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "產品內部";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "運輸紙箱內";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "產品外面";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "難以將產品連接到另一個產品 ";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "難以將產品與其他產品斷開連接";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "鬆散的連接";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "在單個產品中分離組件";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "產品與其他產品的分離/斷開";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "在運輸紙箱的外部";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "在二次包裝/外包裝袋的內側";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "在二次包裝/外包裝袋的外面";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "不流動";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "受限制或部分流動";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "條碼問題 - 掃描時顯示的信息不正確";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "難以掃描/無法掃描條碼";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "難以辨認的標籤";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "標籤不正確";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "標籤不完整";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "標籤（產品、盒子/紙箱、運輸清單）沒有相同的產品信息";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "標籤與其他產品過於相似";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "缺少標籤";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "缺少條碼";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "收到冷凍產品";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "收到解凍的產品";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "是，警報未知";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "是，請詳述";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "是 - 輸液管 (Ttransfer Set) 無法完全打開";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "是 - 輸液管 (Ttransfer Set) 無法完全關閉";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "是 - 旋轉接頭太緊，輸液管 (Ttransfer Set)根本無法打開";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "是 - 旋轉接頭太緊，輸液管 (Ttransfer Set)根本無法關閉";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "盒子或外袋";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "最後充填管上的藍色夾子";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "卡匣";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "排水管接頭和拉環蓋";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "引流取樣點";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "管路";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "魯爾接頭/穿刺接頭";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "整理盤";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "病人端管路上的末端拉環帽/末端保護器套";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "拉環帽/末端保護套";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "加熱管上的紅色夾子";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "定位點";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "供給管上的白色夾子";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "米色導管轉連接器";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "插入芯片";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "深藍色接頭";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "淡藍色主體";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "淺藍色拉環帽";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "淺藍色";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "矽膠管";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "鈦接頭";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "紫外線(UV燈)接頭";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "白色旋轉接頭";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "是 - 請描述損壞 (請輸入)";
translations[OPTION_MONTHOPTIONS_JAN] = "一月";
translations[OPTION_MONTHOPTIONS_FEB] = "二月";
translations[OPTION_MONTHOPTIONS_MAR] = "三月";
translations[OPTION_MONTHOPTIONS_APR] = "四月";
translations[OPTION_MONTHOPTIONS_MAY] = "五月";
translations[OPTION_MONTHOPTIONS_JUN] = "六月";
translations[OPTION_MONTHOPTIONS_JUL] = "七月";
translations[OPTION_MONTHOPTIONS_AUG] = "八月";
translations[OPTION_MONTHOPTIONS_SEP] = "九月";
translations[OPTION_MONTHOPTIONS_OCT] = "十月";
translations[OPTION_MONTHOPTIONS_NOV] = "十一月";
translations[OPTION_MONTHOPTIONS_DEC] = "十二月";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "其他";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "其他";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "其他（請輸入)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "其他（請輸入）";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "以上皆非";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "否";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "是";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "否";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "是";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "否";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "是";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "否";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "是";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "已詢問但未知";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "否";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "未知";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "是";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "否";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "是";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "否";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "是";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "否";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "未知";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "是";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "否";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "是";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "否";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "是";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "否";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "是";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "否";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "是";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "否";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "是";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "否";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "是";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "否";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "是";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "否";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "是";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "否";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "是";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "否";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "未知";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "是";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "否";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "否";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "是";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "否";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "是";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "否";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "是";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "否";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "是";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "否";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "是";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "否";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "是";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "否";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "是";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "否";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "是";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "否";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "是";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "否";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "未知";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "是";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "否";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "否";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "是";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "否";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "是";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "否";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "是";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "否";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "未知";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "是";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "否";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "是";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "否";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "是";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "否";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "是";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "否";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "是";
translations[OPTION_vaporizerSightGlassOptions_NO] = "否";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "未知";
translations[OPTION_vaporizerSightGlassOptions_YES] = "是";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "否";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "是";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "否";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "是";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "否";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "是";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "否";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "是";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "否";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "是";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "否";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "未知";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "是";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "否";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "未知";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "是";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "否";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "是";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "否";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "未知";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "是";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "否";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "未知";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "是";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "否";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "是";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "否";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "是";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "否";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "是";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "否";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "未知";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "是";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "否";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "是";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "否";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "未知";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "是";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "否";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "是";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "否";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "是";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "否";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "未知";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "是";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "未知";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "是";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "否";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "是";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "否";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "是";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "否";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "是";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "否";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "未知";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "是";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "否";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "是";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "否";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "是";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "否";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "是";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "否";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "是";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "否";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "未知";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "是";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "否";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "未知";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "是";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "否";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "否";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "是";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "否";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "否";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "是";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "否";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "未知";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "是";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "否";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "未知";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "是";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "否";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "是";
translations[OPTION_WITHPUMPOPTIONS_NO] = "否";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "未知";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "否";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "未知";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "是";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "否";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "否";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "是";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "否";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "未知";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "是";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "否";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "是";
translations[OPTION_GELPACKSOPTIONS_NO] = "否";
translations[OPTION_GELPACKSOPTIONS_YES] = "是";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "否";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "是";
translations[OPTION_ALARMOPTIONS_NO] = "否";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "未知";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "否";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "未知";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "是";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "否";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "未知";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "否";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "是";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "否";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "是";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "否";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "未知";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "否";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "未知";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "是";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "其他（請輸入）";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "否";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "是";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "否";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "是";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "否";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "是";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "已詢問但未知";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "已詢問但未知";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "未知";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "否";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "以上皆非";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "否 - 請描述顏色 (輸入)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "未知";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "未知";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "是- 請說明使用的工具 (請輸入)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "分離";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "無";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "未知";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "是 - 其他（請輸入）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "否";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "公斤";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "磅";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "不";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "未知";
translations[PLEASE_ENTER_THE_VALUE] = "請輸入值";
translations[PLEASE_SELECT_THE_VALUE] = "請選擇值";
translations[PLEASE_SELECT_THE_DATE] = "請選擇日期";
translations[PLEASE_CHOOSE_THE_VALUE] = "請選擇值";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "未知";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "大不列顛";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "科索沃";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "北愛爾蘭";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "阿富汗";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "奧蘭群島";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "阿爾巴尼亞";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "阿爾及利亞";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "美屬薩摩亞";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "安道爾";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "安哥拉";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "安奎拉";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "南極洲";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "安地卡及巴布達";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "阿根廷";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "亞美尼亞";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "阿魯巴";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "澳洲";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "奧地利";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "亞塞拜然";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "巴哈馬";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "巴林";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "孟加拉國";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "巴貝多";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "白俄羅斯";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "比利時";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "貝里斯";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "貝南";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "百慕達";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "不丹";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "玻利維亞";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "波士尼亞與赫塞哥維納";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "波札那";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "布威島";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "巴西";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "英屬印度洋領地";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "汶萊";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "保加利亞";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "布吉納法索";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "蒲隆地";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "柬埔寨";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "喀麥隆";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "加拿大";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "維德角";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "開曼群島";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "中非共和國";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "查德";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "智利";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "中國";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "聖誕島";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "科克斯（基靈）群島";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "哥倫比亞";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "科摩羅";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "剛果";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "剛果民主共和國";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "庫克群島";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "哥斯大黎加";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "象牙海岸";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "克羅埃西亞";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "古巴";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "賽普勒斯";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "捷克共和國";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "丹麥";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "吉布地";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "多米尼克";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "多明尼加共和國";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "厄瓜多";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "埃及";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "薩爾瓦多";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "赤道幾內亞";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "厄利垂亞";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "愛沙尼亞";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "衣索比亞";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "福克蘭群島 (馬維納斯群島) ";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "法羅群島";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "斐濟";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "芬蘭";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "法國";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "法屬圭亞那";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "法屬玻里尼西亞";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "法屬南部屬地";
translations[OPTION_COUNTRYOPTIONS_GABON] = "加彭";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "甘比亞";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "喬治亞州";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "德國";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "迦納";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "直布羅陀";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "希臘";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "格陵蘭";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "格瑞那達";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "瓜地洛普";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "關島";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "瓜地馬拉";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "耿西";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "幾內亞";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "幾內亞比索";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "蓋亞那";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "海地";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "赫德島及麥唐納群島";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "羅馬教廷（梵蒂岡）";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "洪都拉斯";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "香港";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "匈牙利";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "冰島";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "印度";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "印尼";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "伊朗";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "伊拉克";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "愛爾蘭";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "曼島";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "以色列";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "義大利";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "牙買加";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "日本";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "澤西島";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "約旦";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "哈薩克";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "肯亞";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "基里巴斯";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "北韓";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "南韓";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "科威特";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "吉爾吉斯";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "寮國";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "拉脫維亞";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "黎巴嫩";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "賴索托";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "賴比瑞亞";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "利比亞";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "列支敦士登";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "立陶宛";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "盧森堡";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "澳門";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "馬其頓，前南斯拉夫共和國";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "馬達加斯加";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "馬拉威";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "馬來西亞";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "馬爾地夫";
translations[OPTION_COUNTRYOPTIONS_MALI] = "馬利";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "馬爾他";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "馬紹爾群島";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "馬丁尼克";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "茅利塔尼亞";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "模里西斯";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "馬約特";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "墨西哥";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "密克羅尼西亞聯邦";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "摩爾多瓦";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "摩納哥";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "蒙古";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "蒙特內哥羅共和國";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "蒙哲臘";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "摩洛哥";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "莫三比克";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "緬甸";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "納米比亞";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "諾魯";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "尼泊爾";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "荷蘭";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "新喀裡多尼亞";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "紐西蘭";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "尼加拉瓜";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "尼日";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "奈及利亞";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "紐埃";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "諾福克島";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "北馬里亞納群島";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "挪威";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "阿曼";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "巴基斯坦";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "帛琉";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "巴勒斯坦領土，被佔領";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "巴拿馬";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "巴布亞紐幾內亞";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "巴拉圭";
translations[OPTION_COUNTRYOPTIONS_PERU] = "秘魯";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "菲律賓";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "皮特肯群島";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "波蘭";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "葡萄牙";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "波多黎各";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "卡達";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "留尼旺";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "羅馬尼亞";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "俄羅斯聯邦";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "盧安達";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "聖巴泰勒米";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "聖赫勒拿";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "聖基茨和尼維斯";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "聖盧西亞";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "聖馬丁";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "聖皮埃爾和密克隆";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "聖文森特和格林納丁斯";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "薩摩亞";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "聖馬力諾";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "聖多美普林西比";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "沙烏地阿拉伯";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "塞內加爾";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "塞爾維亞";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "塞席爾";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "獅子山共和國";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "新加坡";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "斯洛伐克";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "斯洛維尼亞";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "所羅門群島";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "索馬利亞";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "南非";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "南喬治亞州和南桑威奇群島";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "西班牙";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "斯里蘭卡";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "蘇丹";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "蘇里南";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "斯瓦巴和揚馬延";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "史瓦濟蘭";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "瑞典";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "瑞士";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "敘利亞";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "台灣";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "塔吉克";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "坦尚尼亞聯合共和國";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "泰國";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "東帝汶";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "多哥";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "托克勞";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "湯加";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "千里達及托巴哥";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "突尼西亞";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "土耳其";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "土庫曼";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "土克凱可群島";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "吐瓦魯";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "烏干達";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "烏克蘭";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "阿拉伯聯合大公國";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "英國";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "美國";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "美國本土外小島嶼";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "烏拉圭";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "烏茲別克";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "萬那杜共和國";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "委內瑞拉";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "越南";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "維爾京群島，英國";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "美國維爾京群島";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "瓦利斯和富圖納";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "西撒哈拉";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "葉門";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "贊比亞";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "津巴布韋";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "否";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "未知";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "是";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "我已閱讀並理解Vantive產品反饋門戶鏈接的隱私聲明。";
translations[PRODUCT_LOT] = "產品批號";
translations[SHIPPING_DISTRIBUTION_LABEL] = "運輸/分銷標籤";
translations[CARTON_LABEL] = "紙箱標籤";
translations[INTERNAL_PRODUCT_LABEL] = "內部產品標籤";
translations[TITLE_PD_RENAL] = "PD腎";
translations[TITLE_SOLUTIONS] = "解決方案";
translations[TITLE_ACCESS] = "使用權";
translations[TITLE_ALL_OTHER_PRODUCT] = "所有其他產品";
translations[REPORTED_PROBLEM] = "報告的問題";
translations[LOGIN] = "登錄";
translations[SYSTEM_MENU] = "系統菜單";
translations[INITIATE_PRODUCT_FEEDBACK] = "開始產品回饋通報";
translations[FEEDBACK_STATUS] = "反饋狀態";
translations[OKTACALLBACK] = "Okta回調";
translations[VALID_EMAIL] = "請輸入有效的電子郵件地址";
translations[VALID_NUMERIC] = "請輸入完整號碼";
translations[PLEASE_UPLOAD_IMAGE] = "請上傳圖片";
translations[VALID_DATE] = "請選擇有效日期";
translations[QUANTITY] = "數量";
translations[EDIT] = "編輯";
translations[DELETE] = "刪除";
translations[LOT_SERIAL_NO] = "批號/序列號";
translations[LOT_NUMBER_NOT_FOUND] = "查無產品批號";
translations[SEARCHING_LOT_NUMBER] = "搜尋產品批號";
translations[PRODUCT_CODE_NOT_FOUND] = "查無產品代碼";
translations[SEARCHING_PRODUCT_CODE] = "搜尋產品代碼";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "檔案格式 (無法支援 .asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps…等格式)";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "您附加的檔案超過儲存限制，請壓縮檔案或另外附加其他檔案";
translations[IMAGE_ICON] = "點選圖片標示以選擇選項";
translations[LOGIN_TO_ACCOUNT] = "登入帳戶";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "登錄到您的帳戶";
translations[PASSWORD] = "密碼";
translations[SIGN_IN] = "登入";
translations[UNKNOWN] = "未知";
translations[ASKED_UNKNOWN] = "已詢問但未知";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "選擇國家";
translations[CHINESE_SIMPLIFIED_CHINESE] = "中文 (簡體中文)";
translations[DUTCH] = "荷蘭文";
translations[ENGLISH] = "英文";
translations[FRENCH] = "法文";
translations[GERMAN] = "德文";
translations[ITALIAN] = "義大利文";
translations[JAPANESE] = "日文";
translations[KOREAN] = "韓文";
translations[MANDARIN_TRADITIONAL_CHINESE] = "中文 (繁體中文)";
translations[POLISH] = "波蘭文";
translations[PORTUGUESE] = "葡萄牙文";
translations[SPANISH] = "西班牙文";
translations[THAI] = "泰文";
translations[TURKISH] = "土耳其文";
translations[VIETNAMESE] = "越南文";
translations[BROWSE] = "瀏覽";
translations[FEEDBACK_SUBMITTED] = "已提交反饋";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "您的產品回饋已成功提交。感謝您的通報。您將收到一封包含通報編號的電子郵件。作為醫療產品的供應商，客戶對我們產品的滿意度和反饋對於我們提供最高質量產品的目標至關重要。 請聯繫";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "如果您有任何疑問或其他信息。";
translations[CLOSE] = "關";
translations[PATIENT_AGE] = "病患年齡";
translations[ENTER_AGE] = "輸入年齡";
translations[PATIENT_DOB] = "病患年出生日期";
translations[RELEVANT_ATTACHMENTS] = "請提供相關附件";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "輸入您的Vantive帳號資訊";
translations[GET_PRODUCT_DETAILS] = "獲取產品詳情";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "使用上圖（圖 2）確定報告問題的位置";
translations[FACILITY_ADDRESS] = "院所地址";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "另一個院所地址";
translations[CHOOSE_PRODUCT_CODE] = "請選擇您鍵入通報批號的產品型號";
translations[DECLINE] = "拒絕";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "博內爾島、聖尤斯特歇斯島和薩巴島";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "庫拉索";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "南蘇丹";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "史瓦帝尼";
translations[FORM_HELP_TEXT] = "表此段有說明提示";
translations[YOUR_FIRST_NAME] = "您的名字";
translations[YOUR_LAST_NAME] = "您的姓氏";
translations[MY_FIRST_NAME] = "我的名字";
translations[MY_LAST_NAME] = "我的姓";
translations[PATIENT_FIRST_NAME] = "病患的名字";
translations[PATIENT_LAST_NAME] = "病患姓氏";
translations[REPORTER_FIRST_NAME] = "通報人名字";
translations[REPORTER_LAST_NAME] = "通報人姓氏";
translations[EMPLOYEE_FIRST_NAME] = "員工名字";
translations[EMPLOYEE_LAST_NAME] = "員工姓氏";
translations[END_USER_CUSTOMER_FIRST_NAME] = "使用者/客戶聯絡人名字";
translations[END_USER_CUSTOMER_LAST_NAME] = "使用者/客戶聯絡人姓氏";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "其他聯絡人名字";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "其他聯絡人姓氏";
translations[COPYRIGHT] = "版權所有 ©";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "保留所有權利 | 版本";
translations[ADD_ADDITIONAL_CONTACT] = "添加其他聯絡人";
translations[CONTACT_ME] = "客戶不希望被聯絡。如有任何其他問題，請與我聯絡。";
translations[DO_NOT_CONTACT] = "請勿聯絡";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "使用者/客戶設施名稱";
translations[END_USER_CUSTOMER_PHONE] = "使用者/客戶院所電話號碼";
translations[END_USER_CUSTOMER_EMAIL] = "使用者/客戶電子郵件地址";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "使用者/客戶院所地址";
translations[SAME_AS_PATIENT_ADDRESS] = "與患者地址相同";
translations[SAME_AS_REPORTER_ADDRESS] = "與通知人的地址相同";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "與用戶/客戶機構地址相同";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "使用上圖（圖 3）確定報告問題的位置";
translations[CONTACT_US] = "聯繫我們";
translations[LANDING_BRIEF_FOR_DEVICE] = "請聯絡本地技術服務中心取得機器維修、零件、服務或技術支援";
translations[PATIENT_SEX] = "患者性行为";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "西人/兒童";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "西女人/女孩";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "跨性別男/跨性男/女對男";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "跨性別女性/跨性婦女/男女對女";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "其他性別類別；請註明";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "拒絕回答";
translations[ATTENTION_NEEDED] = "!!!需要緊急注意：您的產品反饋入口網站提交失敗！";
translations[SUBMIT_ERR_MSG] = "如要重新提交，請按一下「確定」，然後按一下「提交」，或將您的投訴電子郵件發送至 (@@@)。";
translations[SUBMIT_RETRY_MSG] = "如果您重新提交，請確認您在您的電子郵件箱中收到來自產品反饋入口網站的確認電子郵件。如果沒有收到確認電子郵件，表示提交無法成功，您必須將投訴電子郵件發送至 (@@@)。";
translations[OK] = "OK";

export default lang;